var basqueTranslation = {
    translations: {
        philippinePassport: "Filipinetako Pasaportea",
        seamanBook: "Marinoaren Liburua",
        philSysID: "PhilSys IDa",
        iBP: "Filipinetako Abokatu Bategindua (IBP)",
        driversLicense: "Gidabaimena",
        loading: "Kargatzen...",
        loadingDataProvider: "Datu hornitzailea kargatzen...",
        tallySheetImport: {
            title: "Eskrutinio-akten inportazioak",
            subtitle: "Inportatu ES&S edo CSV eskrutinio-akten fitxategiak, aurreikusi sortutako hautetsontziak eta onartu eskrutinio-aktak sortu aurretik.",
            createTitle: "Inportatu eskrutinio-aktak",
            detailTitle: "Eskrutinio-aktaren inportazioa",
            empty: "Oraindik ez dago eskrutinio-akten inportaziorik.",
            emptyBody: "Hasi hauteskunde ekitaldi honetarako ES&S Enhanced XML edo CSV kanoniko fitxategi bat inportatuz.",
            sourceFormat: {
                ESS_ENHANCED_XML: "ES&S Enhanced XML",
                CANONICAL_CSV: "CSV kanonikoa",
            },
            channel: {
                PAPER: "Papera",
                POSTAL: "Postaz",
                IN_PERSON: "Aurrez aurre",
            },
            table: {
                created: "Sortua",
                createdBy: "Sortzailea",
                file: "Fitxategia",
                format: "Formatua",
                channel: "Kanala",
                status: "Egoera",
                labels: "Etiketak",
                annotations: "Oharrak",
                actions: "Ekintzak",
            },
            summary: {
                imported: "Inportatuak",
                changed: "Aldatuak",
                new: "Berriak",
                unchanged: "Aldaketarik gabe",
                conflicted: "Gatazkan",
                errors: "Erroreak",
            },
            status: {
                PENDING_REVIEW: "Berrikuspenaren zain",
                APPROVED: "Onartua",
                DISAPPROVED: "Ez onartua",
                FAILED_VALIDATION: "Balidazioak huts egin du",
                CONFLICTED: "Gatazkan",
                NEW: "Berria",
                CHANGED: "Aldatua",
                UNCHANGED: "Aldaketarik gabe",
            },
            fields: {
                format: "Formatua",
                channel: "Kanala",
                supportedFormats: "Onartutako formatuak: XML, CSV",
                generatedTallySheet: "Sortutako eskrutinio-akta",
                sourceCandidates: "Jatorrizko hautagaien IDak",
                none: "Bat ere ez",
            },
            actions: {
                create: "Inportatu eskrutinio-aktak",
                review: "Berrikusi",
                source: "Iturria",
                cancel: "Ezeztatu",
                preview: "Aurreikusi",
                save: "Gorde inportazioa",
                approve: "Onartu",
                disapprove: "Ez onartu",
                close: "Itxi",
                openExisting: "Ireki dagoena",
            },
            notifications: {
                selectFile: "Hautatu inportatzeko fitxategi bat aurreikusi aurretik",
                duplicateSource: "Jatorrizko fitxategiaren hash hau lehendik dagoen eskrutinio-akten inportazio batean agertzen da.",
                uploadUrlError: "Ezin izan da igotzeko URLa sortu",
                uploadError: "Ezin izan da inportazio-fitxategia igo",
                previewEmpty: "Aurreikuspenaren erantzuna hutsik zegoen",
                previewError: "Ezin izan da inportazioa aurreikusi",
                importEmpty: "Inportazioaren erantzuna hutsik zegoen",
                created: "Eskrutinio-aktaren inportazioa sortu da",
                createError: "Ezin izan da inportazioa sortu",
                reviewEmpty: "Berrikuspenaren erantzuna hutsik zegoen",
                conflicted: "Inportazioak zaharkitutako oinarri-gatazkak ditu",
                approved: "Inportazioa onartu da",
                disapproved: "Inportazioa ez da onartu",
                reviewError: "Ezin izan da inportazioa berrikusi",
                sourceUrlError: "Ezin izan da jatorrizko deskarga-URLa sortu",
                sourceDownloadError: "Ezin izan da jatorrizko fitxategia deskargatu",
            },
            pagination: {
                range: "{{rangeStart}}-{{rangeEnd}} / {{total}}",
                previous: "Aurrekoa",
                next: "Hurrengoa",
            },
        },
        reconciliation: {
            menuButton: "Kanpo bozk. sink.",
            categories: {
                VOTED_INTERNET: "Internet bidez bozkatu du",
                VOTED_OTHER_CHANNEL: "Beste kanal batetik bozkatu du",
                DISABLED_DELETE_CALL: "Bozkatzailea desgaituta",
                DELETION_REVERTED: "Ezabaketa desegina",
                PROFILE_UPDATE: "Profila eguneratuta",
                VOTER_ADDED: "Bozkatzailea gehituta",
                REENABLED: "Bozkatzailea berriz gaituta",
                VOTED_UNMARKED: "Bozkatzaileari boto-marka kendu zaio",
                ROW_FAILURE: "Errenkada-errorea",
            },
            table: {
                voterId: "Bozkatzailearen IDa",
                field: "Eremua",
                category: "Kategoria",
                currentValue: "Uneko balioa",
                newValue: "Balio berria",
                reason: "Arrazoia",
                rowLabel: "Errenkada",
                noDifferences: "Ez da desberdintasunik aurkitu - sistemak sinkronizatuta daude.",
            },
            wizard: {
                title: "Kanpoko bat-egite sinkronizazioa",
                subtitle: "Sinkronizatu bozkatzaileen zerrenda kanpoko sistemarekin",
                drop: {
                    description: "Jaregin kanpoko sistemak sortutako bat-egite fitxategia - bi diffak (kanpoko aldea eta Sequent aldea) automatikoki kalkulatzen dira eta taula bereizietan erakusten dira.",
                    fileFormatLabel: "CSV fitxategia",
                    uploading: "{{fileName}} igotzen eta bi diffak kalkulatzen...",
                },
                review: {
                    fileSummary: "{{fileName}} - {{sequence}} sekuentzia, {{generatedAt}} sortua",
                    rowFailuresWarning: "{{count}} errenkada ezin izan dira modu seguruan bateratu eta bi diffetatik kanpo geratzen dira - ikusi xehetasunak behean.",
                    noDifferences: "Ez dago desberdintasunik - bi sistemak jada sinkronizatuta daude.",
                    diffOnlyDifferences: "Dagoeneko aplikatutako sekuentzia baten konbergentzia-egiaztapena da hau. Aldeak jarraipenerako erakusten dira, baina txanda hau ezin da berriro aplikatu.",
                    externalDiffTitle: "Kanpoko diff-a",
                    sequentDiffTitle: "Sequent diff-a",
                    downloadExternalPatch: "Deskargatu kanpoko adabakia",
                    externalDiffCaption: "Deskargatu adabakia eta eman ezazu kanpoko sistemari tresna honetatik kanpo. Adabakia aplikatu eta hurrengo bat-egite fitxategia sortu ondoren, sakatu 'Atzera' eta jaregin fitxategi hori - 'Aplikatu' gaitzen da taula hau hutsik dagoenean.",
                    noExternalDifferences: "Ez dago desberdintasunik kanpoko aldean.",
                    sequentDiffCaption: "Aplikatu aldaketak zuzenean Sequent-i 'Aplikatu' sakatuz - hauetarako ez da adabaki-fitxategirik sortzen.",
                    noSequentDifferences: "Ez dago desberdintasunik Sequent aldean.",
                },
                applying: {
                    inProgress: "Sequent aldeko aldaketak aplikatzen...",
                    rowFailures: "{{count}} errenkada bat-egite honetatik kanpo geratu dira eta eskuzko jarraipena behar dute - ikusi xehetasunak behean.",
                    rowFailuresTruncated: "{{count}} errenkada-hutsegiteetatik lehen {{shown}} erakusten dira. Ebatzi kausa komuna eta saiatu berriro gainerakoak ikusteko.",
                    success: "Sequent aldeko aldaketa guztiak ondo aplikatu dira.",
                },
                actions: {
                    cancel: "Ezeztatu",
                    back: "Atzera",
                    apply: "Aplikatu",
                    next: "Hurrengoa",
                    startOver: "Hasi berriro",
                    close: "Itxi",
                },
                confirm: {
                    title: "Berretsi bat-egite aldaketak",
                    categoriesNote: "Laranjaz nabarmendutako kategoriek ({{categories}}) boto-egoerari eragiten diote edo bozkatzaileak desgaitzen dituzte.",
                    applyChanges: "Aplikatu aldaketak",
                    continue: "Jarraitu",
                },
                summary: {
                    votedOtherChannel: "{{count}} bozkatzaile beste kanal batetik bozkatu izana adierazten du",
                    disabled: "{{count}} bozkatzaile desgaitzen ditu",
                    reenabled: "{{count}} bozkatzaile berriz gaitzen ditu",
                    votedUnmarked: "{{count}} bozkatzaileari boto-marka kentzen dio",
                    profileUpdated: "{{count}} profil eguneratzen ditu",
                    voterAdded: "{{count}} bozkatzaile gehitzen ditu",
                    prefix: "Honek {{parts}} dituzten aldaketak aplikatuko ditu.",
                    empty: "Ez dago Sequent aldeko aldaketarik aplikatzeko.",
                },
                notifications: {
                    envelopeLoadError: "Ezin izan da bat-egite diff-a kargatu - saiatu berriro.",
                    generateFailed: "Ezin izan da bat-egite diff-a kalkulatu - ikusi zereginen widget-a xehetasunetarako.",
                    applyFailed: "Ezin izan dira Sequent aldeko aldaketak aplikatu - ikusi zereginen widget-a xehetasunetarako.",
                    uploadUrlError: "Ezin izan da igotzeko URLa lortu",
                    generateTaskError: "Ezin izan da bat-egite diff zeregina abiarazi",
                    uploadError: "Ezin izan da bat-egite fitxategia igo",
                    applyTaskError: "Ezin izan da aplikatzeko zeregina abiarazi",
                    applyError: "Ezin izan dira bat-egite aldaketak aplikatu",
                },
            },
        },
        logsScreen: {
            noPermissions: "Ez duzu egunkariak atzitzeko baimenik.",
            title: "Egunkariak",
            subtitle: "Datu-base nagusi eta IAMaren egunkari orokorrak",
            actions: {
                csv: "CSV formatuan esportatu",
                pdf: "PDF formatuan esportatu",
            },
            exportdialog: {
                description: "Mesedez, berretsi ekintza hau exekutatu nahi duzula, denbora pixka bat hartu dezake.",
            },
            column: {
                id: "IDa",
                statement_kind: "Adierazpen mota",
                created: "Sortua",
                statement_timestamp: "Adierazpen denbora-marka",
                message: "Mezua",
                user_id: "Erabiltzaile IDa",
                username: "Erabiltzaile izena",
                sender_pk: "Bidaltzaile Pk",
                log_type: "Egunkari Mota",
                event_type: "Gertaera Mota",
                description: "Deskribapena",
                version: "Bertsioa",
            },
            main: {
                title: "Datu-base Nagusiaren Egunkariak",
            },
            iam: {
                title: "IAM Datu-basearen Egunkariak",
            },
        },
        tasksScreen: {
            noPermissions: "Ez duzu egunkariak atzitzeko baimenik.",
            title: "Ataza Exekuzioa",
            subtitle: "Exekutatutako atazei buruzko informazioa",
            taskInformation: "Ataza Informazioa",
            status: "egoera: {{status}}",
            ok: "Ados",
            column: {
                id: "Indizea",
                name: "Ataza izena",
                type: "Mota",
                execution_status: "Egoera",
                start_at: "Hasiera ordua",
                end_at: "Amaiera ordua",
                executed_by_user: "Exekutatzailea",
                annotations: "Oharrak",
                labels: "Etiketak",
                logs: "Egunkariak",
            },
            tasksExecution: {
                DELETE_TENANT: "Ezabatu erakundea",
                PUBLISH_BALLOT: "Boto-papera argitaratu",
                VOTER_INFORMATION_LETTER: "Bozkatzailearen informazio-gutuna",
                EXPORT_ELECTION_EVENT: "Esportatu Hauteskunde Gertaera",
                CREATE_ELECTION_EVENT: "Sortu Hauteskunde Gertaera",
                IMPORT_ELECTION_EVENT: "Inportatu Hauteskunde Gertaera",
                IMPORT_USERS: "Inportatu Erabiltzaileak",
                EDIT_USER: "Editatu Bozkatzailea",
                IMPORT_CANDIDATES: "Inportatu Hautagaiak",
                EXPORT_VOTERS: "Esportatu Bozkatzaileak",
                CREATE_TRANSMISSION_PACKAGE: "Sortu Transmisio Paketea",
                EXPORT_BALLOT_PUBLICATION: "Esportatu Bozketa Argitalpena",
                EXPORT_ACTIVITY_LOGS_REPORT: "Esportatu Jarduera Egunkarien Txostena",
                GENERATE_REPORT: "Sortu Txostena",
                GENERATE_TRANSMISSION_REPORT: "Sortu Transmisio Txostena",
                EXPORT_TRUSTEES: "Esportatu Fideikomisarioak",
                EXPORT_APPLICATION: "Esportatu Aplikazioak",
                EXPORT_TENANT_CONFIG: "Esportatu Maizter Konfigurazioa",
                IMPORT_TENANT_CONFIG: "Inportatu Maizter Konfigurazioa",
                RENDER_DOCUMENT_PDF: "Errendatu Dokumentu PDFa",
                CREATE_TENANT: "Maizterra Sortu",
                EXPORT_TEMPLATES: "Txantiloiak Esportatu",
                IMPORT_TEMPLATES: "Txantiloiak Inportatu",
                DELETE_ELECTION_EVENT: "Ezabatu Hauteskunde Gertaera",
                DELETE_VOTERS: "Ezabatu bozkatzaileak",
                PREPARE_PUBLICATION_PREVIEW: "Argitalpenaren aurrebista prestatu",
                EXPORT_TALLY_RESULTS_XLSX: "Esportatu zenbaketa-emaitzak XLSX formatuan",
                EXPORT_CERTIFICATE_AUTHORITIES: "Ziurtagiri-agintaritzak esportatu",
                PUBLISH_RESULTS_WEBSITE: "Argitaratu emaitzen webgunea",
            },
            documentAccess: {
                title: "Dokumenturako sarbidea",
                sensitivityNotice: "Informazio sentikorra. Partekatu pasahitz hau aurreikusitako hartzailearekin soilik.",
                passwordLabel: "PDF zifratua irekitzeko pasahitza",
                showPassword: "Erakutsi pasahitza",
                copyPassword: "Kopiatu pasahitza",
                passwordCopied: "Pasahitza kopiatu da",
                passwordError: "Ezin izan da PDFaren pasahitza eskuratu",
                copyError: "Ezin izan da pasahitza kopiatu",
                guidance: "Pasahitza Erakutsi pasahitza aukeratu ondoren bakarrik kargatzen da. Kargatu ondoren, kopiatzeko aukera duen irakurtzeko soilik den eremu bat agertuko da hemen.",
            },
            widget: {
                taskTitle: "Ataza: {{title}}",
                viewTask: "Ikusi Ataza",
                downloadDocument: "Deskargatu Fitxategia",
            },
            exportTasksExecution: {
                success: "Esportazioa arrakastaz amaitu da",
                error: "Errorea Ataza Exekuzioa esportatzerakoan",
            },
        },
        areas: {
            common: {
                title: "Eremuak",
                subTitle: "Eremu konfigurazioa.",
                deleteError: "Errorea eremua ezabatzerakoan",
            },
            createAreaSuccess: "Eremua sortua",
            updateAreaSuccess: "Eremua aldatua",
            createAreaError: "Ezin izan da Eremua sortu",
            sequent_backend_area_contest: "Galderak",
            empty: {
                header: "Ez dago Eremurik oraindik.",
                action: "Sortu Eremua",
            },
            formImputs: {
                allowEarlyVoting: "Onartu Goiztiarra Bozketa",
            },
        },
        integrationsScreen: {
            common: {
                gapiKey: "Google Calendar Zerbitzu Kontu Giltza",
                gapiEmail: "Google Calendar Autentifikazio Helbide Elektronikoa",
            },
            errors: {
                invalidGapiKey: "Google Calendar Zerbitzu Kontu Giltza formatu baliogabea",
            },
        },
        lookAndFeelScreen: {
            common: {
                helpLinks: "Laguntza Estekak",
                logoUrl: "Logo URLa",
                css: "CSS Pertsonalizatua",
            },
            errors: {
                invalidHelpLinks: "Laguntza Esteken formatu baliogabea",
            },
        },
        electionTypeScreen: {
            noPermissions: "Ez duzu ezarpenak atzitzeko baimenik.",
            common: {
                title: "Hauteskunde Mota",
                subtitle: "Hauteskunde mota konfigurazioa",
                onlineVoting: "Lineko Bozketa",
                kioskVoting: "Kiosko Bozketa",
                telephoneVoting: "Telefono Bozketa",
                settingTitle: "Ezarpenak",
                settingSubtitle: "Konfigurazio Orokorra",
                sms: "SMS",
                mail: "Emailak",
                createNew: "Sortu Hauteskunde Mota",
                emptyHeader: "Ez dago Hauteskunde Motarik oraindik.",
                emptyBody: "Bat sortu nahi duzu?",
            },
            create: {
                title: "Sortu Hauteskunde Mota",
            },
            edit: {
                title: "Editatu Hauteskunde Mota",
            },
            tabs: {
                votingChannels: "BOZKETA KANALAK",
                electionTypes: "HAUTESKUNDE MOTAK",
                templates: "TXANTILOIAK",
                languages: "HIZKUNTZAK",
                localization: "LOKALIZAZIOA",
                integrations: "Integrazioak",
                lookAndFeel: "Itxura eta Sentimendua",
                schedules: "PROGRAMATUTAKO GERTAERAK",
                trustees: "FIDEIKOMISARIOAK",
                BackupRestore: "Babeskopia / Leheneratu",
            },
        },
        trusteesSettingsScreen: {
            common: {
                emptyHeader: "Ez dago Fideikomisariorik oraindik.",
                createNew: "Sortu Fideikomisarioa",
                title: "Fideikomisarioa",
                subtitle: "Fideikomisario konfigurazioa",
                emptyBody: "Bat sortu nahi duzu?",
            },
            create: {
                title: "Sortu Fideikomisarioa",
            },
            edit: {
                title: "Editatu Fideikomisarioa",
            },
        },
        scheduleScreen: {
            noPermissions: "Ez duzu ezarpenak atzitzeko baimenik.",
            createScheduleSuccess: "Ordutegia sortua",
            createScheduleError: "Errorea ordutegia sortzerakoan",
            deleteScheduleSuccess: "Ordutegia ezabatua",
            deleteScheduleError: "Errorea ordutegia ezabatzerakoan",
            common: {
                title: "Programatua",
                subtitle: "Ordutegi konfigurazioa",
                createNew: "Sortu Ordutegia",
                emptyHeader: "Ez dago Ordutegiarik oraindik.",
                emptyBody: "Bat sortu nahi duzu?",
            },
            create: {
                title: "Sortu Ordutegia",
                selectSchedule: "Hautatu ordutegi bat aurrez definitutako zerrendatik edo idatzi pertsonalizatu bat",
            },
            edit: {
                title: "Editatu Ordutegia",
            },
            eventTypes: {
                SYSTEM_LOCKDOWN_FOR_INTERNET_VOTING_SETTINGS: "Sistema blokeoa Internet bozketa ezarpenen amaitzeko",
                START_PRE_REGISTRATION_OVCS: "OVCS aurre-erregistroaren hasiera eta amaiera",
                END_PRE_REGISTRATION_OVCS: "OVCS aurre-erregistroaren amaiera",
                START_TEST_VOTING_PERIOD: "Proba bozketa aldiaren hasiera",
                END_TEST_VOTING_PERIOD: "Proba bozketa aldiaren amaiera",
                START_INTERNET_VOTING_PERIOD: "Internet bozketa aldiaren hasiera",
                END_INTERNET_VOTING_PERIOD: "Internet bozketa aldiaren amaiera",
                LAB_TEST: "Laboratorio proba",
                FIELD_TEST: "Eremu proba",
                MOCK_ELECTIONS: "Hauteskunde faltsuak",
                FTS: "FTS",
            },
        },
        dashboard: {
            voteByDay: "Eguneko botoak",
            votesOverTime: "Botoak denboran zehar",
            timeResolution: "Denbora-bereizmena",
            timeRange: "Denbora-tartea",
            minute: "Minutua",
            hour: "Ordua",
            day: "Eguna",
            votersByChannels: "Kanaleko bozkatzaileak",
            voterLoginURL: "Bozkatzaile Sarrera URLa",
            voterEnrollURL: "Bozkatzaile Matrikula URLa",
            voterEnrollKioskURL: "Bozkatzaile Matrikula Kiosko URLa",
            ipAddress: {
                emptyState: "Ez dago botorik oraindik.",
                title: "IP Helbideak",
                ip: "IP",
                country: "Herrialdea",
                VoteCount: "Boto Kopurua",
                ElectionName: "Hauteskunde Izena",
                VotersId: "Bozkatzaileen IDa",
            },
        },
        electionEventScreen: {
            common: {
                subtitle: "Hauteskunde gertaera konfigurazioa.",
                showMore: "Erakutsi Gehiago",
                showLess: "Erakutsi Gutxiago",
                adminPortal: "Admin Portala",
                allowPublishAfterLockdown: "Hauteskunde gertaera argitalpena blokearen ondoren soilik baimendu",
                reset: "Berrezarri iragazki pertsonalizatua",
            },
            edit: {
                general: "Orokorra",
                dates: "Datak",
                customUrls: "URL Aurrizki Pertsonalizatuak",
                votingPeriod: "Bozketa Aldia",
                language: "Hizkuntza",
                languageAndRegion: "Hizkuntza eta eskualdea",
                allowed: "Baimendutako Bozketa Kanalak",
                materials: "Laguntza Materialak",
                ballotDesign: "Bozketa Diseinua",
                templates: "Txantiloiak",
                reorder: "Berrantolatu hauteskundeak",
                advancedConfigurations: "Konfigurazio Aurreratuak",
                importCandidates: "Inportatu Hautagaiak",
                custom_filters: "Iragazki pertsonalizatuak",
                voter_authentication: "Bozkatzaile Autentifikazioa",
                realm_attributes: "Keycloak-en realm atributuak",
                realm_attributes_load_error: "Errorea Keycloak-en realm atributuak kargatzean",
                realm_attributes_update_error: "Errorea Keycloak-en realm atributuak eguneratzean",
                realm_attributes_not_loaded: "Keycloak-en realm atributuak ez dira kargatu; aldaketak ez dira gorde",
                password_policy: "Pasahitz-politika",
                password_policy_load_error: "Errorea Keycloak-en pasahitz-politika kargatzean",
                password_policy_update_error: "Errorea Keycloak-en pasahitz-politika eguneratzean",
                password_policy_not_loaded: "Keycloak-en pasahitz-politika ez da kargatu; aldaketak ez dira gorde",
            },
            customUrls: {
                login: "Sarrera",
                enrollment: "Matrikula",
            },
            localization: {
                emptyHeader: "Ez da hizkuntzarik ezarri gertaeraarako",
                selectLanguage: "Hautatu Hizkuntza",
                notify: {
                    success: "Lokalizazioa arrakastaz eguneratua",
                    error: "Lokalizazio eguneraketa huts egin du",
                    duplicateKey: "Giltza eta atari-esparru hori dituen ordezkapen bat badago.",
                    invalidDateTimeFormat: "Data/orduaren formatu baliogabea. Erabili yyyy, MM, dd, HH, mm, ss tokenak (adib. dd/MM/yyyy HH:mm).",
                },
                common: {
                    title: "Lokalizazioa",
                    subTitle: "Lokalizazio konfigurazioa",
                },
                labels: {
                    key: "Giltza",
                    scope: "Atariaren esparrua",
                    value: "Balioa",
                },
                scopes: {
                    legacy: "Legatua ({{portal}})",
                    global: "Globala",
                    votingPortal: "Bozketa-ataria",
                    ballotVerifier: "Boto-paperen egiaztatzailea",
                    resultsPortal: "Emaitzen ataria",
                    adminPortal: "Administrazio-ataria",
                },
            },
            field: {
                passwordPolicy: {
                    minimumLength: "Gutxieneko luzera",
                    maximumLength: "Gehieneko luzera",
                    includeUppercase: "Sartu letra larriak",
                    includeLowercase: "Sartu letra xeheak",
                    includeDigits: "Sartu digituak",
                    includeSpecialCharacters: "Sartu karaktere bereziak",
                    help: {
                        minimumLength: "Pasahitzak izan behar duen gutxieneko karaktere kopurua.",
                        maximumLength: "Pasahitzak izan dezakeen gehieneko karaktere kopurua.",
                        includeUppercase: "Pasahitzak gutxienez letra larri bat izan behar du.",
                        includeLowercase: "Pasahitzak gutxienez letra xehe bat izan behar du.",
                        includeDigits: "Pasahitzak gutxienez digitu bat izan behar du.",
                        includeSpecialCharacters: "Pasahitzak gutxienez karaktere berezi bat izan behar du.",
                    },
                    notConfigured: "Ez dago pasahitz-politikarik konfiguratuta. Gordetzean, beheko balio lehenetsiak aplikatuko dira.",
                    errors: {
                        lengthRange: "Pasahitzaren luzera-balioek 1 eta 256 arteko zenbaki osoak izan behar dute.",
                        minimumExceedsMaximum: "Gutxieneko luzerak ezin du gehieneko luzera gainditu.",
                        characterClassRequired: "Hautatu gutxienez karaktere-klase bat pasahitzerako.",
                    },
                },
                name: "Izena",
                alias: "Ezizena",
                description: "Deskribapena",
                startDateTime: "Hasiera Data eta Ordua",
                endDateTime: "Amaiera Data eta Ordua",
                language: "Hizkuntza",
                votingChannels: "Bozketa Kanalak",
                materialActivated: "Laguntza Materialak Aktibatuta",
                supportMaterialsPolicy: {
                    label: "Laguntza Materialen Politika",
                    helperText: "Bozkatzeko Derrigorrezkoa aukeratzen bada, bozkatzaileek boto bat eman ahal izan aurretik Laguntza Material bakoitza ireki eta irakurri dutela berretsi beharko dute.",
                    options: {
                        off: "Desaktibatuta",
                        optional: "Aukerakoa",
                        mandatory_for_voting: "Bozkatzeko Derrigorrezkoa",
                    },
                },
                materialTitle: "Izenburua",
                materialSubTitle: "Azpititulua",
                logoUrl: "Logo URLa",
                userVerification: "Bozkatzaileak eskuz egiaztatzeko erabiliko den txantiloi pertsonalizatu bat sar dezakezu",
                redirectFinishUrl: "Berbideratu Amaiera URLa",
                kioskRedirectFinishUrl: "Kioskoaren amaierako berbideratze URLa",
                css: "CSS Pertsonalizatua",
                skipElectionList: "Saltatu Hauteskunde Zerrenda Pantaila",
                showUserProfile: "Erakutsi Erabiltzaile Profila",
                showCastVoteLogs: {
                    policyLabel: "Erakutsi Logs Bozketa Taba",
                    options: {
                        "show-logs-tab": "Erakutsi Logs Bozketa Taba",
                        "hide-logs-tab": "Ez Erakutsi Logs Bozketa Taba",
                    },
                },
                lockdownState: {
                    policyLabel: "Blokeo Egoera",
                    options: {
                        "locked-down": "Blokeatuta",
                        "not-locked-down": "Blokeatu gabe",
                    },
                },
                decodedBallots: {
                    policyLabel: "Deskodetutako boto-paperak emaitzen datu-basean sartu",
                    options: { "included": "Sartu", "not-included": "Ez sartu" },
                },
                contestEncryptionPolicy: {
                    options: {
                        "single-contest": "Galdera Bakarra",
                        "multiple-contests": "Galdera Anitzak",
                    },
                    policyLabel: "Galdera zifratze politika",
                },
                votingPortalDateTimeFormat: {
                    policyLabel: "Bozketa-atariko data eta orduaren formatua",
                    helperText: 'Gertaera osoari aplikatzen zaio. Hizkuntza bakoitzeko gainjartzeko, gehitu "votingPortalDateTimeFormat" gakoa Lokalizazioa fitxan, yyyy, MM, dd, HH, mm, ss tokenak erabiliz (adib. dd/MM/yyyy HH:mm). Ikus dokumentazioa xehetasunetarako.',
                    options: {
                        "legacy-gb-24h": "GB zaharra 24 h (dd/MM/yyyy HH:mm, 24h)",
                        "iso-local": "ISO lokala (yyyy-MM-dd HH:mm)",
                        "us-12h": "AEB 12 h (MM/dd/yyyy h:mm AM/PM)",
                        "locale-medium": "Locale Medium (data ertaina, ordu laburra)",
                        "date-only": "Date Only (ordurik gabe)",
                        "custom": "Formatu pertsonalizatua",
                    },
                    customFormat: {
                        label: "Data eta ordu formatu pertsonalizatua",
                        helperText: "Erabili yyyy, MM, dd, HH, mm, ss tokenak (adib. dd/MM/yyyy HH:mm). Beste edozein karaktere literalki erakusten da.",
                        invalid: "Formatu baliogabea. Erabili yyyy, MM, dd, HH, mm, ss tokenetako bat gutxienez.",
                    },
                },
                countDownPolicyOptions: {
                    NO_COUNTDOWN: "Ez dago Kontaketa Atzera",
                    COUNTDOWN: "Kontaketa Atzera",
                    COUNTDOWN_WITH_ALERT: "Kontaketa Atzera alerta batekin",
                    sectionTitle: "Bozketa Portala",
                    policyLabel: "Bozketa Portal Kontaketa Atzera politika",
                    coundownSecondsLabel: "iraungitze aurretik kontaketa atzera erakusteko denbora segundotan",
                    alertSecondsLabel: "iraungitze aurretik Saioa Itxi alerta erakusteko denbora segundotan",
                },
                voterSigningPolicy: {
                    "policyLabel": "Bozkatzaile Sinadura Politika",
                    "no-signature": "Sinadurarik ez",
                    "with-signature": "Sinadura batekin",
                },
                VoterCertificatePolicy: {
                    policyLabel: "Bozkatzailearen ziurtagiri digitalaren politika",
                    enabled: "Gaituta",
                    disabled: "Desgaituta",
                },
                enrollment: {
                    policyLabel: "Matrikula",
                    options: {
                        enabled: "Gaituta",
                        disabled: "Desgaituta",
                    },
                },
                otp: {
                    policyLabel: "OTP",
                    options: {
                        enabled: "Gaituta",
                        disabled: "Desgaituta",
                    },
                },
                ceremoniesPolicy: {
                    policyLabel: "Giltza/Zenbaketa zeremonien politika",
                    options: {
                        "automated-ceremonies": "Zeremonia automatikoak baimendu",
                        "manual-ceremonies": "Eskuzko zeremoniak",
                    },
                },
                automaticRecountPolicy: {
                    policyLabel: "Inportazioa onartu ondorengo zenbaketa automatikoa",
                    options: {
                        enabled: "Gaituta",
                        disabled: "Desgaituta",
                    },
                },
                weightedVotingPolicy: {
                    policyLabel: "Bozketa Ponderatuaren Politika",
                    options: {
                        "areas-weighted-voting": "Eremuen araberako Bozketa Ponderatua",
                        "voters-weighted-voting": "Bozkatzaileen araberako Bozketa Ponderatua",
                        "disabled-weighted-voting": "Bozketa Ponderatua Desgaituta",
                    },
                    noDelegated: "Bozkatzaileen araberako Bozketa Ponderatua ezin da Boto Delegatuarekin konbinatu",
                    noDecodedBallots: "Bozkatzaileen araberako Bozketa Ponderatua ezin da emaitzetan deszifratutako botoak sartzearekin konbinatu",
                },
                delegatedVotingPolicy: {
                    policyLabel: "Botoa Eskualdatzeko Politika",
                    options: {
                        enabled: "Gaituta",
                        disabled: "Desgaituta",
                    },
                },
                languageDetectionPolicy: {
                    policyLabel: "Hizkuntza detekzio politika",
                    options: {
                        "browser-detect": "Arakatzailetik detektatu",
                        "force-default": "Lehenetsia behartu",
                    },
                },
                numberFormatPolicy: {
                    policyLabel: "Zenbakien formatuaren politika",
                    helperText: "Emaitzetako, paneletako eta txostenetako zenbakiei aplikatzen zaie.",
                    unknownPolicy: "'{{policy}}' formatu ezezaguna, honela erakusten da: {{sample}}",
                },
            },
            error: {
                endDate: "Amaiera data hasiera data baino beranduagokoa izan behar da",
                startDate: "Hasiera data etorkizunean egon behar da",
                noResult: "Ez dago Hauteskunde Gertaerarik oraindik",
                endDateInvalid: "Amaiera data etorkizunean egon behar da",
            },
            voters: {
                title: "Bozkatzaileak",
            },
            createElectionEventSuccess: "Hauteskunde Gertaera sortua",
            createElectionEventError: "Errorea hauteskunde gertaera sortzerakoan",
            ivr: {
                tabs: {
                    config: "Konfigurazioa",
                    blacklist: "Blokeatze-zerrenda",
                    prompts: "Ahots-mezuak",
                    emulator: "Emuladorea",
                },
                common: {
                    saveSuccess: "Behar bezala gorde da",
                    saveError: "Ezin izan da gorde",
                    deleteSuccess: "Behar bezala ezabatu da",
                    deleteError: "Ezin izan da ezabatu",
                },
                config: {
                    configuredPhone: "Konfiguratutako telefono-zenbakia",
                    infoMsg: "Konfiguratu IVRaren fluxua eta haren propietateak behean. Xehetasun gehiagorako, jarri harremanetan Sequent-ekin.",
                },
                prompts: {
                    emptyMsg: "Oraindik ez da promptik sortu",
                    infoMsg: "Konfiguratu IVRak erabiltzen dituen promptak. Iragarpen-promptak nahitaezkoak dira, eta sistema-promptak nahi diren hizkuntzetarako gainidatz daitezke. SSML onartzen da, hizkuntzak nahasteko ere bai.",
                    editorTitle: "Prompta",
                    editorSubtitle: "Promptaren konfigurazioa",
                },
                blacklist: {
                    columns: {
                        phone: "Telefono-zenbakia",
                        reason: "Arrazoia",
                        createdAt: "Sortze-data",
                        createdBy: "Nork sortua",
                        createdBefore: "Noiz baino lehen sortua",
                        createdAfter: "Noiz baino ondoren sortua",
                    },
                    emptyMsg: "Ez dago sarrerarik blokeatze-zerrendan",
                    infoMsg: "Konfiguratu IVRaren blokeo-zerrenda. Zenbaki hauetatik datozen deiak automatikoki deskonektatuko ditu sistemak.",
                    noFilterMatch: "Ez dago emandako iragazkiekin bat datorren sarrerarik",
                    phoneRequired: "Telefono-zenbakia nahitaezkoa da",
                },
                emulator: {
                    infoMsg: "Hautatu eremu bat eta nahi dituzun hauteskundeak IVR saioa probatzeko.",
                    apiStatus: {
                        unavailable: "Emuladore-sistema ez dago erabilgarri zure ingurunean",
                        loading: "Emuladore-sistema kargatzen",
                        error: "Errorea emuladore-sistema kargatzean",
                    },
                    hints: {
                        title: "Aholkuak",
                        publishRequired: "Hauteskundeetan, galderetan edo hautagaietan egindako edozein aldaketa lehenik argitaratu behar da erabilgarri egon dadin. Dagokion eremurako azkenik argitaratutako boto-paper estiloak soilik erabiliko dira emuladorean.",
                        eventChangesImmediate: "Hauteskunde-ekitaldian egindako aldaketak, hala nola IVR konfigurazioa edo mezuen gainidazketak, berehala egongo dira erabilgarri emuladorearen saioa berrabiaraztean.",
                        credentials: 'Baliozko bozkatzaile-IDa eta PINa "123" eta "123" dira.',
                    },
                    sendDtmf: "Bidali DTMF sarrera",
                    sendTimeout: "Bidali denbora-muga",
                    disconnected: "Deskonektatuta",
                    startSession: "Hasi saio berria",
                    endSession: "Amaitu saioa",
                    noStylesFound: "Ez da aurkitu zure hautapenekin bat datorren argitaratutako boto-paper estilorik",
                    inputPlaceholder: "Idatzi sarrera (gehienezko digitu kopurua={{maxDigits}}, baliozko sarrerak={{validInputs}}, denbora-muga={{timeout}} s)",
                    blacklistCaller: "Blokeatu deitzailea",
                    elections: "Hauteskundeak",
                    area: "Eremua",
                },
            },
            stats: {
                elegibleVoters: "Bozkatzaile Eskudunak",
                voters: "Egiazko Bozkatzaileak",
                elections: "Hauteskundeak",
                contests: "Galderak",
                areas: "Eremuak",
                sentEmails: "Bidali diren emailak",
                sentSMS: "Bidali diren SMSak",
                calendar: {
                    title: "Egutegia",
                    scheduled: "Programatua",
                },
            },
            keys: {
                createNew: "Sortu Giltzen Zeremonia",
                emptyHeader: "Ez dago Giltzen Zeremoniarik oraindik.",
                statusLabel: "Egoera",
                waitingKeys: "Giltzen Sorkuntza itxoiten..",
                started: "Hasita:",
                actions: {
                    participate: "Parte hartu giltzen zeremonian",
                    view: "Ikusi giltzen zeremonia",
                },
                breadCrumbs: {
                    configure: "Konfiguratu",
                    ceremony: "Zeremonia",
                    created: "Amaituta",
                    start: "Hasi",
                    status: "Egoera",
                    download: "Deskargatu",
                    check: "Egiaztatu",
                    success: "Amaituta",
                },
                notify: {
                    participateNow: "Giltzen zeremonoia batean parte hartzeko gonbidatu zaituzte. Mesedez <1>sakatu zeremoniaren Giltza Ekintzaren</1> parte hartzeko.",
                },
            },
            tabs: {
                dashboard: "Panela",
                monitoring: "Monitorizazioa",
                data: "Datuak",
                ivr: "IVR",
                localization: "Lokalizazioa",
                voters: "Bozkatzaileak",
                areas: "Eremuak",
                keys: "Giltzak",
                tally: "Zenbaketa",
                tallySheetImports: "Akten inportazioa",
                publish: "Argitaratu",
                logs: "Egunkariak",
                tasks: "Atazak",
                events: "Programatutako Gertaerak",
                notifications: "Jakinarazpenak",
                reports: "Txostenak",
                approvals: "Onespenak",
                cas: "Ziurtagiriak",
            },
            tally: {
                emptyHeader: "Ez dago Zenbaketarik oraindik.",
                title: "Hauteskunde Gertaera Zenbaketa",
                elections: "Hauteskundeak",
                electionNumber: "Hauteskunde Kopurua",
                trustees: "Fideikomisarioak",
                permissionLabels: "Baimen Etiketak",
                status: "Egoera",
                tallyType: {
                    label: "Zenbaketa Mota",
                    ELECTORAL_RESULTS: "Hauteskunde Emaitzak",
                    INITIALIZATION_REPORT: "Hasierako Emaitzak",
                },
                create: {
                    title: "Sortu Zenbaketa",
                    subtitle: "Sortu Zenbaketa berri bat Hauteskunde Gertaera honetarako",
                    createTallyButton: "Hasi Zenbaketa Zeremonia",
                    createInitializationReportButton: "Sortu Hasierako Txostena",
                    error: {
                        create: "Errorea Zenbaketa sortzerakoan",
                    },
                    success: "Zenbaketa sortua",
                },
                logs: {
                    noLogs: "Ez daude egunkaririk eskuragarri",
                },
                notify: {
                    noKeysTally: "Zenbaketa Zeremonia ezin da hasi Giltzen Zeremonia arrakastaz osatu arte.",
                    noPublication: "Zenbaketa Zeremonia ezin da hasi Argitaratu fitxan argitalpen bat sortu arte.",
                    participateNow: "Zenbaketa zeremonoia batean parte hartzeko gonbidatu zaituzte. Mesedez <1>sakatu zeremoniaren Giltza Ekintzaren</1> parte hartzeko.",
                    startDisabled: "Ezin duzu zeremoniarekin jarraitu hauteskunderik hautatu ez delako edo hauteskundeak argitaratu ez direlako.",
                    ceremonyDisabled: "Ezin duzu zeremoniarekin jarraitu zenbaketa saioa konektatu ez delako edo zeremonoia hastea baimenduta ez dagoelako.",
                },
            },
            importAreas: {
                title: "Inportatu Eremuak",
                subtitle: "Inportatu eremuen datuak",
                areaParagraph: "Inportatu eremuak Komaz Banandutako Balioen (CSV) formatuko kalkulu-orri fitxategi bat erabiliz.",
                importSuccess: "Eremuak Arrakastaz Inportatuak",
                importError: "Errorea Eremuak inportatzerakoan",
                upsert: "Eguneratu Eremuak",
            },
            import: {
                eetitle: "Inportatu Hauteskunde Gertaera",
                eesubtitle: "Inportatu hauteskunde gertaera datuak",
                title: "Inportatu Bozkatzaileak",
                subtitle: "Inportatu bozkatzaileen datuak",
                voters: "Bozkatzaileak",
                votersParagraph: "Inportatu bozkatzaileak Komaz Banandutako Balioen (CSV) formatuko kalkulu-orri fitxategia erabiliz. Deskargatu inportazio CSV fitxategiaren adibidea hemen.",
                electionEventParagraph: "Inportatu Hauteskunde Gertaerak JSON fitxategia erabiliz.",
                elections: "Hauteskundeak",
                areas: "Eremuak",
                sha: "Osotasun Egiaztapena (SHA-256)",
                cancel: "Ezeztatu",
                import: "Inportatu",
                fileUploadSuccess: "Fitxategia zerbitzarira igo da - baina ez da inportatu oraindik",
                fileUploadError: "Errorea fitxategia igotzean",
                importVotersSuccess: "Bozkatzaileen Inportazioa Arrakastaz Programatua",
                importVotersError: "Errorea Bozkatzaileak inportatzerakoan",
                importElectionEventSuccess: "Hauteskunde gertaera arrakastaz inportatua",
                importElectionEventError: "Errorea hauteskunde gertaera inportatzerakoan",
                shaDialog: {
                    ok: "Bai, Inportatu Osotasun Egiaztapenik gabe",
                    cancel: "Itzuli",
                    title: "Inportatu Osotasun Egiaztapenik gabe?",
                    description: "Ez duzu Osotasun Egiaztapena (SHA-256) eremua bete. Mesedez, berretsi fitxategi egokia inportatzen ari zarela eta inportatu nahi duzula.",
                },
                passwordDialog: {
                    title: "Deszifratze Pasahitza",
                    description: "Sartu pasahitza fitxategia deszifratzeko",
                    label: "Pasahitza",
                    copyPassword: "Kopiatu Pasahitza",
                    ok: "Ados",
                },
            },
            export: {
                title: "Esportatu Hauteskunde Gertaera",
                subtitle: "Esportazioa eragiketa luzea izan daiteke. Ziur zaude erregistroak esportatu nahi dituzula?",
                encryptWithPassword: "Zifratu Pasahitzarekin",
                passwordForcedNote: "Artxiboa pasahitzarekin babestuko da nolanahi ere: txostenak, eskaerak eta iragarki-taulako datuak beti zifratzen dira. Markatu laukia bozkatzaileen eremu sekretu deszifratuak ere sartzeko.",
                includeVoters: "Sartu Bozkatzaileak",
                activityLogs: "Jarduera Egunkariak",
                bulletinBoard: "Iragarki Taula",
                publications: "Argitalpenak",
                s3Files: "S3 Fitxategiak",
                scheduledEvents: "Programatutako Gertaerak",
                exportSuccess: "Hauteskunde Gertaera arrakastaz esportatua",
                exportError: "Errorea Hauteskunde Gertaera esportatzerakoan",
                passwordTitle: "Pasahitza",
                passwordDescription: "Fitxategia deszifratzeko pasahitza:",
                copiedSuccess: "Pasahitza arbelera kopiatu da",
                copiedError: "Errorea pasahitza kopiatzerakoan",
                reports: "Txostenak",
                applications: "Aplikazioak",
                tally: "Zenbaketa",
                certificates: "Ziurtagiriak",
            },
            taskNotification: "{{action}} hasi da. Bere egoera Ataza Exekuzio taulan ikus dezakezu.",
        },
        electionScreen: {
            common: {
                title: "Hauteskundea",
                subtitle: "Hauteskunde konfigurazioa.",
                fileLoaded: "Fitxategia kargatua",
                noPermission: "Ez duzu hauteskunde hau atzitzeko baimenik.",
            },
            edit: {
                general: "Orokorra",
                dates: "Datak",
                votingPeriod: "Bozketa Aldia",
                language: "Hizkuntza",
                allowed: "Baimendutako Bozketa Kanalak",
                default: "Lehenetsia",
                defaultLang: "Lehenetsitako hizkuntza",
                receipts: "Jaso-agiriak",
                image: "Irudia",
                advanced: "Konfigurazio Aurreratua",
                numAllowedVotes: "Baimendutako boto kopurua",
                reorder: "Berrantolatu galderak",
                castVoteConfirm: "Boto Berrespena Modal",
                gracePeriodPolicy: "Grazia Aldia",
                allowTallyPolicy: "Baimendu Zenbaketa",
                permissionLabel: "Baimen Etiketa",
                custom_filters: "Iragazki pertsonalizatuak",
            },
            field: {
                name: "Izena",
                language: "Hizkuntza",
                votingChannels: "Bozketa Kanalak",
                startDateTime: "Hasiera Data eta Ordua",
                endDateTime: "Amaiera Data eta Ordua",
                startDateTimeWithTimezone: "Hasiera Data eta Ordua ({{timezone}})",
                endDateTimeWithTimezone: "Amaiera Data eta Ordua ({{timezone}})",
                scheduledOpening: "Programatutako Irekiera",
                scheduledClosing: "Programatutako Itxiera",
                alias: "Ezizena",
                description: "Deskribapena",
                securityConfirmationHtml: "Segurtasun-berrespena HTML",
                ivrPrompt: "IVR mezua",
                externalId: "Kanpoko IDa",
            },
            securityConfirmationPolicy: {
                label: "Segurtasun-berrespeneko kontrol-laukiaren politika",
                none: "Bat ere ez",
                mandatory: "Derrigorrezkoa",
            },
            error: {
                fileError: "Errorea fitxategia igotzean",
                fileLoaded: "Fitxategia kargatua",
                endDate: "Amaiera data hasiera data baino beranduagokoa izan behar da",
                startDate: "Hasiera data etorkizunean egon behar da",
                endDateInvalid: "Amaiera data etorkizunean egon behar da",
            },
            createElectionEventSuccess: "Hauteskunde Gertaera sortua",
            createElectionEventError: "Errorea hauteskunde gertaera sortzerakoan",
            tabs: {
                dashboard: "Panela",
                monitoring: "Monitorizazioa",
                data: "Datuak",
                voters: "Bozkatzaileak",
                publish: "Argitaratu",
                logs: "Egunkariak",
                approvals: "Onespenak",
                tallySheets: "Kontaketa orriak",
            },
            gracePeriodPolicy: {
                "label": "Grazia Aldi Politika",
                "no-grace-period": "Graziazko aldirik ez",
                "grace-period-without-alert": "Graziazko aldia alertarik gabe",
                "gracePeriodSecs": "Graziazko aldia segundotan",
            },
            allowTallyPolicy: {
                "allowed": "Baimenduta",
                "disallowed": "Baimendu gabe",
                "requires-voting-period-end": "Bozketa Aldi Amaiera Behar du",
            },
            initializeReportPolicy: {
                "label": "Hasierako Txosten Politika",
                "not-required": "Ez da Beharrezkoa",
                "required": "Beharrezkoa",
            },
            castVoteGoldLevelPolicy: {
                label: "Urre maila Autentifikazio Politika",
                options: {
                    "gold-level": "Urre maila Autentifikazioa",
                    "no-gold-level": "Ez da Urre maila Autentifikaziorik",
                },
            },
            slates: {
                enable: {
                    label: "Gaitu hautagai-zerrendak",
                    helper: "Gaituta dagoenean, hautesleek izendun hautagai-zerrenda bat hauta dezakete eta edozein lehia alda dezakete, hautagai independenteak barne.",
                },
                disable: {
                    confirm: "Desgaitu hautagai-zerrendak",
                    message_one: "Hauteskunde honek hautagai-zerrenda {{count}} du. Hautagai-zerrendak desgaitzen badituzu, gordetzean ezabatuko da.",
                    message_many: "Hauteskunde honek {{count}} hautagai-zerrenda ditu. Hautagai-zerrendak desgaitzen badituzu, gordetzean ezabatuko dira.",
                    message_other: "Hauteskunde honek {{count}} hautagai-zerrenda ditu. Hautagai-zerrendak desgaitzen badituzu, gordetzean ezabatuko dira.",
                },
                mobileCandidateLists: {
                    label: "Hautagaien zerrendak mugikorrean",
                    helper: "Nola agertzen den hasieran hautagai-zerrenda bakoitzaren hautagaien zerrenda mugikorrean: Tolestuta edo Zabalduta. Hautesleek beti ireki edo itxi dezakete edozein zerrenda. Mahaigainean hautagai guztiak erakusten dira beti.",
                    options: {
                        collapsed: "Tolestuta",
                        expanded: "Zabalduta",
                    },
                },
            },
            startScreenTitlePolicy: {
                label: "Hasierako pantailaren titulu politika",
                options: {
                    "election": "Hauteskundearen titulua",
                    "election-event": "Hauteskunde-ekitaldiaren titulua",
                },
            },
            consolidatedReportPolicy: {
                label: "Txosten bateratuaren politika",
                options: {
                    "generate": "Sortu",
                    "do-not-generate": "Ez sortu",
                },
            },
            declineToVotePolicy: {
                label: "Bozkatzeari uko egiteko politika",
                options: {
                    enabled: "Gaituta",
                    disabled: "Desgaituta",
                },
            },
            blankBallotsPolicy: {
                label: "Boto-txartel zurien politika",
                options: {
                    enabled: "Gaituta",
                    disabled: "Desgaituta",
                },
            },
            votingScreenBackPolicy: {
                label: "Bozketa-pantailako atzera botoiaren politika",
                options: {
                    "election-selection-screen": "Joan hauteskundeak hautatzeko pantailara",
                    "start-screen": "Joan hauteskundearen hasierako pantailara",
                },
            },
        },
        tenantScreen: {
            common: {
                title: "Maizterrak",
            },
            new: {
                subtitle: "Sortu maizter berria",
            },
            createSuccess: "Maizterra sortua",
            createError: "Errorea maizterra sortzerakoan",
        },
        usersAndRolesScreen: {
            noPermissions: "Ez duzu erabiltzaileak edo rolak atzitzeko baimenik.",
            common: {
                title: "Erabiltzaileak eta Rolak",
                subtitle: "Konfigurazio orokorra",
                mobileNumber: "Mugikorra",
            },
            editPassword: {
                passwordPolicyViolation: "Pasahitzak ez du betetzen hauteskunde-gertaera honetako Pasahitz-politika. Berrikusi politika Hauteskunde-gertaeraren datuak atalean eta idatzi baliozko pasahitz bat.",
                passwordPolicyRules: {
                    minimumLength: "Pasahitzaren gutxieneko luzera {{count}} da.",
                    maximumLength: "Pasahitzaren gehieneko luzera {{count}} da.",
                    uppercase: "Beharrezko letra larriak: {{count}}.",
                    lowercase: "Beharrezko letra xeheak: {{count}}.",
                    digits: "Beharrezko digituak: {{count}}.",
                    specialCharacters: "Beharrezko karaktere bereziak: {{count}}.",
                },
                label: "Aldatu pasahitza",
                temporatyLabel: "Behin-behinekoa",
                temporatyInfo: "Gaituta badago, erabiltzaileak pasahitza aldatu beharko du hurrengo sarreran",
            },
            users: {
                title: "Erabiltzaileak",
                subtitle: "Ikusi eta editatu erabiltzaile datuak",
                review: {
                    title: "Aldaketak berrikusi",
                    subtitle: "Berretsi eguneratze hauek bidali aurretik.",
                    confirm: "Aldaketak berretsi",
                    noChanges: "Ez dago berrikusteko aldaketarik",
                    field: "Eremua",
                    currentValue: "Uneko balioa",
                    newValue: "Balio berria",
                },
                edit: {
                    title: "Erabiltzaile Datuak",
                    subtitle: "Ikusi eta editatu erabiltzailea",
                },
                create: {
                    title: "Erabiltzailea",
                    subtitle: "Sortu erabiltzailea",
                },
                fields: {
                    "has_voted": "Bozkatu du",
                    "support_materials_viewed": "Laguntza Materialak Ikusita",
                    "vote-weight": "Botoaren pisua",
                    "voted-channel": "Boto-kanala",
                    "disable-comment": "Desgaitzeko iruzkina",
                    "username": "Erabiltzaile izena",
                    "first_name": "Izena",
                    "last_name": "Abizena",
                    "email": "Emaila",
                    "enabled": "Gaituta",
                    "emailVerified": "Emaila Egiaztatua",
                    "groups": "Taldeak",
                    "attributes": "Atributuak",
                    "area": "Eremua",
                    "password": "Pasahitza",
                    "repeatPassword": "Errepikatu Pasahitza",
                    "savePassword": "Gorde Pasahitza",
                    "passwordMismatch": "Pasahitzek bat egin behar dute",
                    "passwordLengthValidate": "Pasahitzak gutxienez 8 karaktere izan behar ditu",
                    "passwordUppercaseValidate": "Pasahitzak gutxienez maiuskula bat izan behar du",
                    "passwordLowercaseValidate": "Pasahitzak gutxienez minuskula bat izan behar du",
                    "passwordDigitValidate": "Pasahitzak gutxienez zenbaki bat izan behar du",
                    "passwordSpecialCharValidate": "Pasahitzak gutxienez karaktere berezi bat izan behar du",
                    "trustee": "Fideikomisario gisa jardun",
                    "permissionLabel": "Baimen Etiketa",
                    "authorized-election-ids": "Hauteskundeak",
                },
                delete: {
                    body: "Ziur zaude erabiltzaile hau ezabatu nahi duzula?",
                    bulkBody: "Ziur zaude hautatutako erabiltzaileak ezabatu nahi dituzula?",
                    bulkBodySelected: "Hautatutako {{count}} erabiltzaileak ezabatu? Ezin da desegin.",
                    bulkBodyChoose: "{{count}} erabiltzaile daude hautatuta. Horren ordez, uneko iragazkiekin bat datozen erabiltzaile guztiak ezaba ditzakezu, eta gehiago izan daitezke. Ezin da desegin.",
                    okSelected: "Ezabatu hautatutakoak ({{count}})",
                    okAllMatching: "Ezabatu bat datozen guztiak",
                },
                notifications: {
                    exportError: "Errorea erabiltzaileak esportatzerakoan",
                    deleteError: "Errorea erabiltzailea ezabatzerakoan",
                    deleteSuccess: "Erabiltzailea ezabatua",
                    multipleDeleteSuccess: "Erabiltzaileak ezabatuak",
                },
            },
            voters: {
                voterInformationLetter: {
                    label: "Bozkatzailearen informazio-gutuna",
                    generate: "Sortu",
                    confirmation: "Bozkatzaile honentzako informazio-gutuna sortu? Pasahitz berri bat esleituko da eta PDF zifratu batean sartuko da.",
                    generationStarted: "Informazio-gutuna sortzen hasi da",
                    generationError: "Ezin izan da informazio-gutuna sortu",
                    policyNotConfigured: "Pasahitz-politika ez dago konfiguratuta. Konfiguratu Hauteskunde-gertaeraren datuak atalean gutuna sortu aurretik.",
                    policyMinimumLengthMissing: "Pasahitz-politikak gutxieneko luzera izan behar du gutuna sortu aurretik.",
                    policyCharacterClassMissing: "Pasahitz-politikak gutxienez karaktere-klase bat izan behar du gutuna sortu aurretik.",
                },
                title: "Bozkatzaileak",
                subtitle: "Ikusi eta editatu bozkatzaile datuak",
                secretAttribute: {
                    storedPlaceholder: "Gordetako balio zifratua",
                    reveal: "Erakutsi",
                    hide: "Ezkutatu",
                    revealError: "Ezin izan da bozkatzailearen eremu zifratua erakutsi",
                    includeInExport: "Sartu deszifratutako bozkatzailearen eremu sekretuak",
                    exportWarning: "Esportazio sentikorra: deskargatutako CSVak eremu hauek testu arruntean izango ditu.",
                    clear: "Garbitu",
                    add: "Gehitu balioa",
                    remove: "Kendu balioa",
                },
                review: {
                    title: "Aldaketak berrikusi",
                    subtitle: "Berretsi eguneratze hauek bidali aurretik.",
                    confirm: "Aldaketak berretsi",
                    noChanges: "Ez dago berrikusteko aldaketarik",
                    field: "Eremua",
                    currentValue: "Uneko balioa",
                    newValue: "Balio berria",
                },
                logs: {
                    label: "Erabiltzailearen Egunkariak",
                },
                create: {
                    title: "Bozkatzailea",
                    subtitle: "Sortu Bozkatzailea",
                },
                manualVerification: {
                    label: "Eskuz Egiaztatu",
                    verify: "Eskuz egiaztatu bozkatzaile hau",
                    body: "Eskuz egiaztatu bozkatzaile hau. Bozkatzaileari online KYC saltatzeko sartzen ahalbidetzen dion QR Kode esteka bat duen PDF bat lortuko duzu.",
                    noEmailOrPhone: "Bozkatzaile hau ezin da eskuz egiaztatu email helbiderik edo telefono zenbakirik ez duelako.",
                },
                emptyHeader: "Ez dago bozkatzailerik oraindik.",
                askCreate: "Bat sortu nahi duzu?",
                errors: {
                    editError: "Errorea bozkatzailea editatzerakoan",
                    editErrorReason: "Errorea bozkatzailea editatzerakoan: {{reason}}",
                    editSuccess: "Bozkatzailea editatua",
                    createError: "Errorea bozkatzailea sortzerakoan",
                    createErrorReason: "Errorea bozkatzailea sortzerakoan: {{reason}}",
                    createSuccess: "Bozkatzailea sortua",
                    attribute: {
                        invalidNamed: '"{{field}}" baztertu da: {{constraint}}',
                        fieldsToCorrect: "Eremu batzuk zuzendu behar dira gorde aurretik",
                        hintBetween: "{{min}} eta {{max}} karaktere artean",
                        hintMin: "Gutxienez {{min}} karaktere",
                        hintMax: "Gehienez {{max}} karaktere",
                        andMore: "eta beste {{count}}",
                        invalidLength: '"{{field}}" eremuak {{min}} eta {{max}} karaktere artean izan behar ditu',
                        tooShort: '"{{field}}" eremuak gutxienez {{min}} karaktere izan behar ditu',
                        tooLong: '"{{field}}" eremuak gehienez {{max}} karaktere izan behar ditu',
                        required: '"{{field}}" nahitaezkoa da',
                        invalidEmail: '"{{field}}" baliozko helbide elektronikoa izan behar da',
                        invalidFormat: '"{{field}}" ez dauka espero den formatua',
                        invalid: '"{{field}}" balio baliogabea dauka',
                    },
                    createPasswordError: "Bozkatzailea sortua, baina ezin izan da bere pasahitza ezarri",
                    createPasswordErrorReason: "Bozkatzailea sortua, baina ezin izan da bere pasahitza ezarri: {{reason}}",
                },
                delete: {
                    body: "Ziur zaude bozkatzaile hau ezabatu nahi duzula?",
                    bulkBody: "Ziur zaude hautatutako bozkatzaileak ezabatu nahi dituzula?",
                    bulkBodySelected: "Hautatutako {{count}} bozkatzaileak ezabatu? Ezin da desegin.",
                    bulkBodyChoose: "{{count}} bozkatzaile daude hautatuta. Horren ordez, uneko iragazkiekin bat datozen bozkatzaile guztiak ezaba ditzakezu, eta gehiago izan daitezke. Ezin da desegin.",
                    okSelected: "Ezabatu hautatutakoak ({{count}})",
                    okAllMatching: "Ezabatu bat datozen guztiak",
                },
                notifications: {
                    exportError: "Errorea bozkatzaileak esportatzerakoan",
                    deleteError: "Errorea bozkatzailea ezabatzerakoan",
                    deleteSuccess: "Bozkatzailea ezabatua",
                    multipleDeleteSuccess: "Bozkatzaileak ezabatuak",
                    manualVerificationError: "Errorea bozkatzailea eskuz egiaztatzerakoan",
                    manualVerificationSuccess: "Arrakastaz egiaztatu da eskuz bozkatzailea, PDFa deskargatzen..",
                },
            },
            roles: {
                title: "Rolak",
                edit: {
                    title: "Rol Datuak",
                    subtitle: "Ikusi eta editatu rola",
                },
                create: {
                    title: "Rola",
                    subtitle: "Sortu rola",
                },
                errors: {
                    createError: "Errorea rola sortzerakoan",
                    createSuccess: "Rola sortua",
                },
                fields: {
                    name: "Izena",
                },
                delete: {
                    body: "Ziur zaude rol hau ezabatu nahi duzula?",
                },
                notifications: {
                    deleteError: "Errorea rola ezabatzerakoan",
                    deleteSuccess: "Rola ezabatua",
                    permissionEditError: "Errorea baimena editatzerakoan",
                    permissionEditSuccess: "Baimena editatua",
                },
            },
            permissions: {
                "voter-information-letter": "Bozkatzailearen informazio-gutuna sortu",
                "admin-user": "Admin Erabiltzailea",
                "admin-dashboard-view": "Admin Panela Ikusi",
                "application-export": "Aplikazio Esportazioa",
                "application-import": "Aplikazio Inportazioa",
                "tenant-create": "Sortu Maizterra",
                "tenant-read": "Irakurri Maizterra",
                "tenant-write": "Editatu Maizterra",
                "tenant-delete": "Ezabatu Maizterra",
                "election-event-create": "Sortu Hauteskunde Gertaera",
                "election-event-read": "Irakurri Hauteskunde Gertaera",
                "election-event-write": "Editatu Hauteskunde Gertaera",
                "keycloak-realm-attributes-read": "Irakurri Keycloak-en realm atributuak",
                "keycloak-realm-attributes-write": "Editatu Keycloak-en realm atributuak",
                "election-event-delete": "Ezabatu Hauteskunde Gertaera",
                "voter-create": "Sortu Bozkatzailea",
                "voter-read": "Irakurri Bozkatzailea",
                "voter-write": "Editatu Bozkatzailea",
                "voter-secret-attribute-read": "Erakutsi Bozkatzailearen Eremu Sekretuak",
                "voter-secret-attribute-write": "Editatu Bozkatzailearen Eremu Sekretuak",
                "user-create": "Sortu Erabiltzailea",
                "user-read": "Irakurri Erabiltzailea",
                "user-write": "Editatu Erabiltzailea",
                "user-permission-create": "Sortu Erabiltzaile Baimena",
                "user-permission-read": "Irakurri Erabiltzaile Baimena",
                "user-permission-write": "Editatu Erabiltzaile Baimena",
                "role-create": "Sortu Rola",
                "role-read": "Irakurri Rola",
                "role-write": "Editatu Rola",
                "role-assign": "Esleitu Rola",
                "communication-template-create": "Sortu Komunikazio Txantiloia",
                "communication-template-read": "Irakurri Komunikazio Txantiloia",
                "communication-template-write": "Editatu Komunikazio Txantiloia",
                "notification-read": "Irakurri Jakinarazpena",
                "notification-write": "Editatu Jakinarazpena",
                "notification-send": "Bidali Jakinarazpena",
                "area-read": "Irakurri Eremua",
                "area-write": "Editatu Eremua",
                "election-state-write": "Editatu Hauteskunde Egoera",
                "election-type-create": "Sortu Hauteskunde Mota",
                "election-type-read": "Irakurri Hauteskunde Mota",
                "election-type-write": "Editatu Hauteskunde Mota",
                "voting-channel-read": "Irakurri Bozketa Kanala",
                "voting-channel-write": "Editatu Bozketa Kanala",
                "trustee-create": "Sortu Fideikomisarioa",
                "trustee-read": "Irakurri Fideikomisarioa",
                "trustee-write": "Editatu Fideikomisarioa",
                "tally-read": "Irakurri Zenbaketa",
                "tally-start": "Hasi Zenbaketa",
                "tally-write": "Editatu Zenbaketa",
                "tally-results-read": "Irakurri Zenbaketa Emaitzak",
                "publish-read": "Irakurri Argitalpena",
                "publish-write": "Editatu Argitalpena",
                "publish-results-read": "Irakurri Emaitzen Argitalpena",
                "publish-results-write": "Editatu Emaitzen Argitalpena",
                "logs-read": "Irakurri Egunkariak",
                "tasks-read": "Irakurri Ataza Exekuzioa",
                "keys-read": "Irakurri Giltzak",
                "document-upload": "Igo Dokumentuak",
                "document-download": "Deskargatu Dokumentuak",
                "document-password-read": "Irakurri dokumentuen pasahitzak",
                "tally-sheet-create": "Sortu Zenbaketa Orria",
                "tally-sheet-import-create": "Sortu zenbaketa orrien inportazioa",
                "tally-sheet-import-review": "Berrikusi zenbaketa orrien inportazioa",
                "tally-sheet-import-view": "Ikusi zenbaketa orrien inportazioa",
                "tally-recount-execute": "Exekutatu emaitzen birzenbaketa",
                "trustee-ceremony": "Fideikomisario Zeremonia",
                "tally-sheet-review": "Zenbaketa-orria berrikusi",
                "tally-sheet-view": "Ikusi Zenbaketa Orria",
                "admin-ceremony": "Admin Zeremonia",
                "tally-sheet-delete": "Ezabatu Zenbaketa Orria",
                "cast-vote-read": "Irakurri Emandako Botoak",
                "document-read": "Irakurri Dokumentuak",
                "document-write": "Editatu Dokumentuak",
                "support-material-read": "Irakurri Laguntza Materialak",
                "support-material-write": "Editatu Laguntza Materialak",
                "miru-create": "Miru Sortu",
                "miru-download": "Miru Deskargatu",
                "miru-send": "Miru Bidali",
                "miru-sign": "Miru Sinatu",
                "contest-write": "Editatu Galdera",
                "contest-read": "Irakurri Galdera",
                "candidate-write": "Editatu Hautagaia",
                "candidate-read": "Irakurri Hautagaia",
                "permission-label-write": "Editatu Baimen Etiketa",
                "scheduled-event-write": "Editatu Programatutako Gertaerak",
                "contest-create": "Sortu Galdera",
                "contest-delete": "Ezabatu Galdera",
                "candidate-create": "Sortu Hautagaia",
                "candidate-delete": "Ezabatu Hautagaia",
                "election-create": "Sortu Hauteskundea",
                "election-read": "Irakurri Hauteskundea",
                "election-write": "Editatu Hauteskundea",
                "election-delete": "Ezabatu Hauteskundea",
                "election-event-archive": "Artxibatu Hauteskunde Gertaera",
                "election-data-tab": "Ikusi Hauteskunde Datuak",
                "election-event-areas-tab": "Ikusi Hauteskunde Gertaera Eremuak",
                "election-event-data-tab": "Ikusi Hauteskunde Gertaera Datuak",
                "election-event-keys-tab": "Ikusi Hauteskunde Gertaera Giltzak",
                "election-event-logs-tab": "Ikusi Hauteskunde Gertaera Egunkariak",
                "election-event-publish-tab": "Ikusi Hauteskunde Gertaera Argitalpena",
                "election-event-reports-tab": "Ikusi Hauteskunde Gertaera Txostenak",
                "election-event-scheduled-tab": "Ikusi Hauteskunde Gertaera Programatua",
                "election-event-tally-tab": "Ikusi Hauteskunde Gertaera Zenbaketa",
                "election-event-tasks-tab": "Ikusi Hauteskunde Gertaera Atazak",
                "election-event-voters-tab": "Ikusi Hauteskunde Gertaera Bozkatzaileak",
                "election-publish-tab": "Ikusi Hauteskunde Argitalpena",
                "election-voters-tab": "Ikusi Hauteskunde Bozkatzaileak",
                "report-write": "Editatu Txostenak",
                "report-read": "Irakurri Txostenak",
                "users-menu": "Ikusi erabiltzaileak eta rolak",
                "settings-menu": "Ikusi ezarpenak",
                "templates-menu": "Ikusi txantiloiak",
                "settings-election-types-tab": "Ikusi hauteskunde moten ezarpenak",
                "settings-voting-channels-tab": "Ikusi bozketa kanalen ezarpenak",
                "settings-templates-tab": "Ikusi txantiloien ezarpenak",
                "settings-languages-tab": "Ikusi hizkuntzen ezarpenak",
                "settings-localization-tab": "Ikusi lokalizazio ezarpenak",
                "settings-look-feel-tab": "Ikusi itxura eta sentimendu ezarpenak",
                "settings-trustees-tab": "Ikusi fideikomisarioen ezarpenak",
                "settings-countries-tab": "Ikusi herrialdeen ezarpenak",
                "voter-import": "Inportatu Bozkatzailea",
                "ee-voters-columns": "Ikusi Hauteskunde Gertaera Bozkatzaileen Zutabeak",
                "voter-manually-verify": "Eskuz Egiaztatu Bozkatzailea",
                "ee-voters-logs": "Ikusi Hauteskunde Gertaera Bozkatzaileen Egunkariak",
                "voter-export": "Esportatu Bozkatzailea",
                "ee-voters-filters": "Ikusi Hauteskunde Gertaera Bozkatzaileen Iragazkiak",
                "voter-delete": "Ezabatu Bozkatzailea",
                "voter-change-password": "Aldatu Bozkatzaile Pasahitza",
                "election-event-localization-selector": "Hauteskunde Gertaera Lokalizazio Hautatzailea",
                "localization-create": "Sortu Lokalizazioa",
                "localization-read": "Irakurri Lokalizazioa",
                "localization-write": "Editatu Lokalizazioa",
                "localization-delete": "Ezabatu Lokalizazioa",
                "area-create": "Sortu Eremua",
                "area-delete": "Ezabatu Eremua",
                "area-export": "Esportatu Eremua",
                "area-import": "Inportatu Eremua",
                "area-upsert": "Eguneratu Eremua",
                "election-event-areas-columns": "Hauteskunde Gertaera Eremuen Zutabeak",
                "election-event-areas-filters": "Hauteskunde Gertaera Eremuen Iragazkiak",
                "election-event-tasks-back-button": "Itzuli Hauteskunde Gertaera Atazetara",
                "election-event-tasks-columns": "Hauteskunde Gertaera Atazen Zutabeak",
                "election-event-tasks-filters": "Hauteskunde Gertaera Atazen Iragazkiak",
                "task-export": "Esportatu Atazak",
                "application-read": "Irakurri Aplikazioa",
                "application-write": "Editatu Aplikazioa",
                "logs-export": "Esportatu Egunkariak",
                "election-event-logs-columns": "Hauteskunde Gertaera Egunkarien Zutabeak",
                "election-events-logs-filters": "Hauteskunde Gertaera Egunkarien Iragazkiak",
                "election-event-scheduled-event-columns": "Hauteskunde Gertaera Programatutako Gertaeren Zutabeak",
                "scheduled-event-create": "Sortu Programatutako Gertaera",
                "scheduled-event-delete": "Ezabatu Programatutako Gertaera",
                "election-event-reports-columns": "Hauteskunde Gertaera Txostenen Zutabeak",
                "report-create": "Sortu Txostena",
                "report-delete": "Ezabatu Txostena",
                "report-generate": "Sortu Txostena",
                "report-preview": "Aurreikusi Txostena",
                "monitor-authenticated-voters": "Monitorizatu Autentifikatutako Bozkatzaileak",
                "monitor-all-approve-disapprove-voters": "Irakurri Monitorizazio Onartu Ezarri Bozkatzaileak",
                "monitor-automatic-approve-disapprove-voters": "Irakurri Monitorizazio Automatiko Onartu Ezarri Bozkatzaileak",
                "monitor-manually-approve-disapprove-voters": "Irakurri Monitorizazio Eskuz Onartu Ezarri Bozkatzaileak",
                "monitor-enrolled-overseas-voters": "Irakurri Monitorizazio Matrikulatutako Atzerriko Bozkatzaileak",
                "monitor-posts-already-closed-voting": "Irakurri Monitorizazio Bozketa Itxi duten Postuak",
                "monitor-posts-already-generated-election-results": "Irakurri Monitorizazio Hauteskunde Emaitzak Sortu dituzten Postuak",
                "monitor-posts-already-opened-voting": "Irakurri Monitorizazio Bozketa Ireki duten Postuak",
                "monitor-posts-already-started-counting-votes": "Irakurri Monitorizazio Botoak Zenbatzen Hasi diren Postuak",
                "monitor-posts-initialized-the-system": "Irakurri Monitorizazio Sistema Hasieratu duten Postuak",
                "monitor-posts-started-voting": "Irakurri Monitorizazio Bozketa Hasi duten Postuak",
                "monitor-posts-transmitted-results": "Irakurri Monitorizazio Emaitzak Transmititu dituzten Postuak",
                "monitor-voters-voted-test-election": "Irakurri Monitorizazio Proba Hauteskunden Bozkatu duten Bozkatzaileak",
                "monitor-voters-who-voted": "Irakurri Monitorizazio Bozkatu duten Bozkatzaileak",
                "election-event-publish-preview": "Aurreikusi Hauteskunde Gertaera Argitalpena",
                "election-event-publish-back-button": "Itzuli Hauteskunde Gertaera Argitalpenara",
                "election-event-publish-columns": "Hauteskunde Gertaera Argitalpenaren Zutabeak",
                "election-event-publish-filters": "Hauteskunde Gertaera Argitalpenaren Iragazkiak",
                "publish-create": "Sortu Argitalpena",
                "publish-regenerate": "Bersortu Argitalpena",
                "publish-export": "Esportatu Argitalpena",
                "publish-start-voting": "Hasi Bozketa",
                "publish-pause-voting": "Gelditu Bozketa",
                "publish-stop-voting": "Gelditu Bozketa",
                "publish-changes": "Argitaratu Aldaketak",
                "election-event-publish-view": "Hauteskunde Gertaera Argitalpen Ikusi",
                "election-event-keys-columns": "Hauteskunde Gertaera Giltzen Zutabeak",
                "create-ceremony": "Sortu Zeremonia",
                "export-ceremony": "Esportatu Zeremonia",
                "election-event-tally-columns": "Hauteskunde Gertaera Zenbaketa Zutabeak",
                "election-event-tally-back-button": "Itzuli Hauteskunde Gertaera Zenbaketara",
                "transmition-ceremony": "Transmisio Zeremonia",
                "admin-ip-address-view": "Ikusi IP Helbidea",
                "election-approvals-tab": "Ikusi Hauteskunde Onespenak",
                "election-event-approvals-tab": "Ikusi Hauteskunde Gertaera Onespenak",
                "election-ip-address-view": "Ikusi Hauteskunde IP Helbidea",
                "election-dashboard-tab": "Ikusi Hauteskunde Panela",
                "trustees-export": "Esportatu Fideikomisarioak",
                "user-import": "Inportatu Erabiltzaileak",
                "voter-voted-edit": "Editatu bozkatu duten bozkatzaileak",
                "voter-email-tlf-edit": "Editatu bozkatzaileen email/telefono eremuak",
                "cloudflare-write": "Editatu Herrialde Blokeo Arauak Cloudflare-n",
                "transmission-report-generate": "Sortu Transmisio Txostena",
                "google-meet-link": "Google Meet Esteka Sortu",
                "service-account": "Zerbitzu-kontua",
                "datafix-account": "Datuak zuzentzeko kontua",
                "gold": "Urrea",
                "silver": "Zilarra",
                "election-event-ivr-tab": "Ikusi hauteskunde-gertaeraren IVRa",
                "election-event-cas-tab": "Ikusi hauteskunde-gertaeraren CASa",
                "ca-read": "Irakurri ziurtagiri-agintaritzak",
                "ca-write": "Editatu ziurtagiri-agintaritzak",
                "generate-preview": "Sortu aurrebista",
                "preview-read": "Irakurri aurrebista",
                "tally-resolution-submit": "Bidali zenbaketa-ebazpena",
                "phone-blacklist-read": "Irakurri telefonoen zerrenda beltza",
                "phone-blacklist-create": "Sortu telefonoen zerrenda beltzeko sarrerak",
                "phone-blacklist-update": "Editatu telefonoen zerrenda beltzeko sarrerak",
                "phone-blacklist-delete": "Ezabatu telefonoen zerrenda beltzeko sarrerak",
                "election-event-voter-list-reconciliation": "Berradiskidetu hauteskunde-gertaeraren bozkatzaile-zerrenda",
            },
        },
        generalSettingsScreen: {
            body: "Gaitu hizkuntzak sisteman. Hemen gaitutako hizkuntzak soilik egongo dira eskuragarri hauteskunde gertaeretan.",
        },
        eventsScreen: {
            title: "Programatutako Gertaerak",
            subtitle: "Bozketa aldiaren hasiera edo amaiera bezalako gertaeren exekuzio automatikoaren konfigurazioa kudeatzen du.",
            messages: {
                createSuccess: "Programatutako Gertaera arrakastaz sortua",
                createError: "Errorea Programatutako Gertaera sortzerakoan",
                editSuccess: "Programatutako Gertaera arrakastaz editatua",
                editError: "Errorea Programatutako Gertaera editatzerakoan",
                onlineWithEarlyVoting: "Hasierako programazio batek ezin ditu aldi berean lineako botoa eta aurretiazko botoa ireki: aurretiazko botoak lineako botoa baino lehen hasi behar du.",
            },
            eventType: {
                label: "Mota",
                ALLOW_INIT_REPORT: "Baimendu Hasierako Txostena",
                START_VOTING_PERIOD: "Hasi Bozketa Aldia",
                END_VOTING_PERIOD: "Amaitu Bozketa Aldia",
                ALLOW_VOTING_PERIOD_END: "Baimendu Bozketa Aldi Amaiera",
                START_ENROLLMENT_PERIOD: "Hasi Matrikula Aldia",
                END_ENROLLMENT_PERIOD: "Amaitu Matrikula Aldia",
                START_LOCKDOWN_PERIOD: "Hasi Blokeo Aldia",
                END_LOCKDOWN_PERIOD: "Amaitu Blokeo Aldia",
                ALLOW_TALLY: "Baimendu Zenbaketa",
            },
            election: {
                label: "Hauteskundea",
            },
            empty: {
                header: "Ez dago Programatutako Gertaerarik oraindik.",
                body: "Bat sortu nahi duzu?",
                button: "Sortu Programatutako Gertaera",
            },
            create: {
                title: "Sortu Programatutako Gertaera",
                subtitle: "Sortu Programatutako Gertaera konfigurazio berri bat.",
            },
            edit: {
                title: "Editatu Programatutako Gertaera",
                subtitle: "Editatu Programatutako Gertaera konfigurazioa.",
                delete: "Ziur zaude Programatutako Gertaera hau ezabatu nahi duzula?",
            },
            fields: {
                electionId: "Hauteskundea",
                eventProcessor: "Mota",
                stoppedAt: "Gelditua:",
                scheduledDate: "Programatua:",
            },
        },
        reportsScreen: {
            title: "Txostenak",
            subtitle: "Sortu txostenak hauteskunde gertaeretarako",
            messages: {
                createSuccess: "Txostena arrakastaz sortua",
                createError: "Errorea Txostena sortzerakoan",
                submitError: "Errorea Txostena bidaltzerakoan",
                updateSuccess: "Txostena arrakastaz eguneratua",
                passwordMismatch: "Pasahitza eta pasahitza berretsi ez datoz bat. Mesedez, ziurtatu eremu biek pasahitz bera dutela.",
                incorectPassword: "Pasahitz okerra",
                decryptFileTitle: "Nola deszifratzen den fitxategia",
                decryptInstructions: "1. '-in' :Zifratutako fitxategiaren bidea. \n2. '-out' :Deszifratutako fitxategia gordeko den bidea. \n3. '-pass' :Fitxategia zifratzeko erabilitako pasahitza. \n",
                encryptSuccess: "Txostenaren enkriptatzea behar bezala konfiguratu da",
                encryptError: "Errorea txostenaren enkriptatzea konfiguratzean",
            },
            reportType: {
                BALLOT_RECEIPT: "Bozketa Jasoagiria",
                ELECTORAL_RESULTS: "Hauteskunde Emaitzak",
                MANUAL_VERIFICATION: "Eskuzko Egiaztapena",
                PARTICIPATION_REPORT: "Parte-hartze Txostena",
                STATISTICAL_REPORT: "Txosten Estatistikoa",
                OVCS_EVENTS: "Atzerriko Bozketa Monitorizazioa - OVCS Gertaerak",
                AUDIT_LOGS: "Auditoria Egunkariak",
                ACTIVITY_LOG: "Jarduera Egunkaria",
                STATUS: "Egoera",
                OVCS_INFORMATION: "OVCS Informazioa",
                OVERSEAS_VOTERS: "Atzerriko bozkatzaileen zerrenda",
                OV_USERS_WHO_VOTED: "Bozkatu duten Atzerriko Bozkatzaileen zerrenda",
                OV_WITH_VOTING_STATUS: "Bozketa Egoerarekin Atzerriko Bozkatzaileen zerrenda",
                OVCS_STATISTICS: "Atzerriko Bozketa Monitorizazioa - OVCS Estatistikak",
                PRE_ENROLLED_OV_BUT_DISAPPROVED: "Aurre-matrikulatu baina Ezarri diren ABen zerrenda",
                PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION: "Aurre-matrikulatu baina Eskuzko Baliozkotzearen menpean dauden ABen zerrenda",
            },
            reportEncryptionPolicy: {
                title: "Zifratze Politika",
                UNENCRYPTED: "Zifratu gabe",
                CONFIGURED_PASSWORD: "Konfiguratutako Pasahitza",
            },
            empty: {
                header: "Ez dago Txostenik oraindik.",
                body: "Bat sortu nahi duzu?",
                button: "Sortu Txostena",
            },
            create: {
                title: "Sortu Txostena",
                subtitle: "Sortu Txosten konfigurazio berri bat.",
            },
            edit: {
                title: "Editatu Txostena",
                subtitle: "Editatu Txosten konfigurazioa.",
                delete: "Ziur zaude Txosten hau ezabatu nahi duzula?",
            },
            fields: {
                electionId: "Hauteskundea",
                template: "Txantiloia",
                reportType: "Txosten Mota",
                repeatable: "Errepika daiteke",
                cronExpression: "Cron Adierazpena",
                emailRecipients: "Email Hartzaileak",
                emailRecipientsPlaceholder: "Idatzi emaila eta sakatu Enter",
            },
            delete: {
                body: "Ziur zaude Txosten hau ezabatu nahi duzula?",
            },
            actions: {
                generate: "Sortu",
                delete: "Ezabatu",
                edit: "Editatu",
                preview: "Aurreikusi",
            },
        },
        googleMeet: {
            title: "Google Meet Esteka Sortu",
            generateButton: "Google Meet",
            meetingTitle: "Bileraren Izenburua",
            description: "Deskribapena (Aukerakoa)",
            startDate: "Hasiera Data",
            startTime: "Hasiera Ordua",
            duration: "Iraupena (minutuak)",
            attendeeEmails: "Partaideen Emailak",
            attendeeEmailHelp: "Komaz banandutako emailak bilerako partaideentzat",
            note: "Oharra: Honek zure Google Calendar-en gertaera bat sortuko du Google Meet esteka batekin. Zure Google kontuan saioa hasi beharko duzu.",
            success: "Google Meet Esteka Arrakastaz Sortua!",
            copy: "Arbelera kopiatu",
            copied: "Esteka arbelera kopiatua!",
            instructions: "Partekatu esteka hau partaideekin bileran parte hartzeko. Egutegi gertaera zure Google Calendar-era gehitu da.",
            generating: "Sortzen...",
            generate: "Meet Esteka Sortu",
        },
        common: {
            export: "Esportazioa eragiketa luzea izan daiteke. Ziur zaude erregistroak esportatu nahi dituzula?",
            resources: {
                electionEvent: "Hauteskunde Gertaera",
                election: "Hauteskundea",
                contest: "Galdera",
                candidate: "Hautagaia",
                noResult: {
                    askCreate: "Bat sortu nahi duzu?",
                },
            },
            label: {
                add: "Gehitu",
                actions: "Ekintzak",
                create: "Sortu",
                delete: "Ezabatu",
                archive: "Artxibatu",
                unarchive: "Desartxibatu",
                cancel: "Ezeztatu",
                edit: "Editatu",
                yes: "Bai",
                no: "Ez",
                save: "Gorde",
                close: "Itxi",
                back: "Atzera",
                next: "Hurrengoa",
                warning: "Abisua",
                json: "Aurreikusi",
                noResult: "Ez dago emaitzarik",
                import: "Inportatu",
                export: "Esportatu",
                loadingData: "Datuak kargatzen ...",
                exportFormat: "{{format}} formatuan esportatu - '{{item}}' emaitzak",
                allResults: "hauteskunde gertaera",
                globalAreaResults: "eremu guztiak",
                title: "Izenburua",
                subtitle: "Azpititulua",
                kind: "Fitxategi mota",
                filter: "Iragazki Pertsonalizatuak",
                approve: "Onartu",
                continue: "Jarraitu",
                logout: "Saioa Itxi",
                selectTenant: "Hautatu Maizterra",
                processing: "Prozesatzen...",
                tenantName: "Maizter Izena",
            },
            language: {
                es: "Gaztelania",
                en: "Ingelesa",
                fr: "Frantsesa",
                cat: "Valentziera",
                tl: "Tagaloa",
                gl: "Galiziera",
                nl: "Nederlandera",
                eu: "Euskera",
            },
            channel: {
                online: "Linea",
                kiosk: "Kiosko",
                early_voting: "Aurre-botoa",
                telephone: "Telefono bozketa",
                other: "Beste batzuk",
            },
            message: {
                delete: "Ziur zaude elementu hau ezabatu nahi duzula?",
                continueOrLogout: "Maizter honetara konektatuta egon nahi duzu ala saioa itxi?",
            },
        },
        createResource: {
            electionEvent: "Sortu Hauteskunde Gertaera",
            election: "Sortu Hauteskundea",
            contest: "Sortu Galdera",
            candidate: "Sortu Hautagaia",
            slate: "Sortu Hautagai-zerrenda bat",
        },
        importResource: {
            electionEvent: "Inportatu Hauteskunde Gertaera",
            election: "Inportatu Hauteskundea",
            contest: "Inportatu Galdera",
            candidate: "Inportatu Hautagaia",
            ImportHashMismatch: "Hash-ak ez datoz bat. Osotasun egiaztapen hutsegitea.",
        },
        sideMenu: {
            electionEvents: "Hauteskunde Gertaerak",
            search: "Bilatu",
            usersAndRoles: "Erabiltzaileak eta Rolak",
            logs: "Egunkariak",
            settings: "Ezarpenak",
            help: "Laguntza",
            templates: "Txantiloiak",
            active: "Aktiboa",
            archived: "Artxibatua",
            addResource: {
                electionEvent: "Sortu Hauteskunde Gertaera",
                election: "Sortu Hauteskundea",
                contest: "Sortu Galdera",
                candidate: "Sortu Hautagaia",
            },
            menuActions: {
                archive: {
                    electionEvent: "Artxibatu Hauteskunde Gertaera hau",
                },
                unarchive: {
                    electionEvent: "Desartxibatu Hauteskunde Gertaera hau",
                    election: "Desartxibatu hauteskunde hau",
                    contest: "Desartxibatu Galdera hau",
                    candidate: "Desartxibatu Hautagaia hau",
                },
                remove: {
                    electionEvent: "Kendu Hauteskunde Gertaera hau",
                    election: "Kendu Hauteskunde hau",
                    contest: "Kendu Galdera hau",
                    candidate: "Kendu Hautagaia hau",
                    slate: "Kendu Hautagai-zerrenda hau",
                },
                messages: {
                    confirm: {
                        archive: "Ziur zaude elementu hau artxibatu nahi duzula?",
                        unarchive: "Ziur zaude elementu hau desartxibatu nahi duzula?",
                        delete: "Ziur zaude elementu hau ezabatu nahi duzula?",
                        archiveNamed: 'Ziur zaude "{{name}}" artxibatu nahi duzula?',
                        unarchiveNamed: 'Ziur zaude "{{name}}" desartxibatu nahi duzula?',
                        deleteNamed: 'Ziur zaude "{{name}}" ezabatu nahi duzula?',
                    },
                    notification: {
                        success: {
                            archive: "Elementua artxibatu da",
                            unarchive: "Elementua desartxibatu da",
                            delete: "Elementua ezabatu da",
                            reloading: "Itxaron. Orria une batez berriro kargatuko da.",
                        },
                        error: {
                            archive: "Errorea elementu hau artxibatzen saiatzean",
                            unarchive: "Errorea elementu hau desartxibatzen saiatzean",
                            delete: "Errorea elementu hau ezabatzen saiatzean",
                        },
                    },
                },
            },
        },
        candidateScreen: {
            common: {
                subtitle: "Hautagaia konfigurazioa.",
            },
            edit: {
                externalId: "Kanpoko IDa",
                general: "Orokorra",
                type: "Mota",
                image: "Irudia",
                isDisabled: "Desgaituta",
                isExplicitInvalid: "Baliogabeko Botoa",
                isExplicitBlank: "Boto Zuria",
                isCategoryList: "Kategoria Zerrenda",
                isWriteIn: "Idatzi",
            },
            field: {
                name: "Izena",
                alias: "Ezizena",
                description: "Deskribapena",
            },
            options: {
                "candidate": "Hautagaia",
                "option": "Aukera",
                "write-in": "Idatzi",
                "open-list": "Zerrenda Irekia",
                "closed-list": "Zerrenda Itxia",
                "semi-open-list": "Zerrenda Erdi Irekia",
                "invalid-vote": "Baliogabeko Botoa",
                "blank-vote": "Boto Zuria",
            },
            invalidVotePosition: {
                label: "Baliogabeko Botoaren Posizioa",
                null: "Ezer ez (Lehenetsia)",
                top: "Goian",
                bottom: "Behean",
            },
            error: {},
            createCandidateSuccess: "Hautagaia sortua",
            createCandidateError: "Errorea hautagaia sortzerakoan",
        },
        slateScreen: {
            common: {
                subtitle: "Hautagai-zerrendaren konfigurazioa.",
                newSlate: "Hautagai-zerrenda berria",
                notFound: "Hautagai-zerrenda hau ez da existitzen.",
            },
            tabs: {
                data: "Datuak",
            },
            edit: {
                general: "Orokorra",
                members: "Kideak",
            },
            field: {
                name: "Izena",
                alias: "Ezizena",
                description: "Deskribapena",
                externalId: "Kanpoko IDa",
            },
            members: {
                helper: "Esleitu lehia bakoitzeko gehienezko hautagai kopurura arte. Utzi lehia bat hutsik hautagai-zerrenda honek lehia hori bete gabe uzteko. Inongo hautagai-zerrendatan ez dauden hautagaiak Independente gisa agertzen dira lehia horretan.",
                contest: "Lehia",
                candidate: "Hautagaia",
                noCandidate: "Hautagairik ez",
            },
            messages: {
                saved: "Hautagai-zerrenda gorde da",
                invalid: "Ezin da hautagai-zerrenda gorde. Zuzendu behean zerrendatutako arazoak.",
                error: "Ezin izan da hautagai-zerrenda gorde.",
                unreadable: "Ezin da hauteskundearen hautagai-zerrenden konfigurazioa irakurri.",
            },
        },
        contestScreen: {
            common: {
                subtitle: "Galdera konfigurazioa.",
            },
            edit: {
                externalId: "Kanpoko IDa",
                general: "Orokorra",
                type: "Mota",
                image: "Irudia",
                system: "Bozketa Sistema",
                design: "Bozketa Diseinua",
                reorder: "Berrantolatu hautagaiak",
                policies: "Politikak",
            },
            field: {
                name: "Izena",
                alias: "Ezizena",
                description: "Deskribapena",
            },
            options: {
                "non-preferential": "Ez Lehentasuna",
                "plurality-at-large": "Pluralitatea Orokorrean",
                "instant-runoff": "Berehalako Bigarren Itzulia",
                "random": "Ausazkoa",
                "external-procedure": "Kanpoko prozedura",
                "custom": "Pertsonalizatua",
                "alphabetical": "Alfabetikoa",
            },
            tieBreakingPolicy: {
                label: "Berdinketa hausteko politika",
            },
            auditButtonConfig: {
                "label": "Auditoria Botoi Erakutsi Aukerak",
                "show": "Erakutsi",
                "not-show": "Ez Erakutsi",
                "show-in-help": "Erakutsi Laguntza Elkarrizketa-koadroan",
            },
            underVotePolicy: {
                "label": "Azpi Boto Politika",
                "allowed": "Baimenduta",
                "warn-only-in-review": "Abisatu Berrikuspena",
                "warn": "Abisatu",
                "warn-and-alert": "Abisatu eta Alerta",
                "warn-and-confirm-in-review": "Abisatu eta Berretsi Berrikuspenean",
            },
            invalidVotePolicy: {
                "label": "Baliogabeko Boto Politika",
                "allowed": "Baimenduta",
                "warn": "Abisatu",
                "warn-invalid-implicit-and-explicit": "Abisatu Baliogabeko Inplizitu eta Esplizitua",
                "not-allowed": "Ez Baimenduta",
                "allowed-with-exclusive-explicit": "Baimenduta, Esplizitua Esklusiboa",
            },
            candidatesIconCheckboxPolicy: {
                "label": "Hautagaien kontrol-laukiaren ikono forma",
                "square-checkbox": "Kontrol-lauki Karratua",
                "round-checkbox": "Kontrol-lauki Biribila",
            },
            checkableListPolicy: {
                "allow-selecting-candidates-and-lists": "Hautagaiak eta Zerrendak",
                "allow-selecting-candidates": "Hautagaiak Soilik",
                "allow-selecting-lists": "Zerrendak Soilik",
                "disabled": "Desgaituta",
            },
            collapsibleListsPolicy: {
                "label": "Zerrenda tolesgarriak",
                "disabled": "Desgaituta",
                "enabled-expanded": "Gaituta (zabalik hasten da)",
                "enabled-collapsed": "Gaituta (tolestuta hasten da)",
            },
            blankVotePolicy: {
                "label": "Boto Zuri Politika",
                "allowed": "Baimenduta",
                "warn-only-in-review": "Abisatu Berrikuspena",
                "warn": "Abisatu",
                "not-allowed": "Ez Baimenduta",
            },
            overVotePolicy: {
                "label": "Gain Boto Politika",
                "allowed": "Baimenduta",
                "allowed-with-msg": "Baimenduta Abisu Mezuarekin",
                "allowed-with-msg-and-alert": "Baimenduta Abisu mezu eta Alertarekin",
                "not-allowed-with-msg-and-alert": "Ez Baimenduta Abisu mezu eta Alertarekin",
                "not-allowed-with-msg-and-disable": "Ez Baimenduta Abisu mezuarekin eta Gehiago hautatzea Desgaitu",
            },
            duplicatedRankPolicy: {
                "label": "Boto baliogabea - Bikoiztutako Rankaren Politika",
                "allowed-warn-and-dialog": "Erakutsi ohartarazpena eta elkarrizketa-koadroa (botatzaileak aurrera egin dezake)",
                "not-allowed-warn-and-dialog": "Erakutsi ohartarazpena eta elkarrizketa-koadroa (botatzaileak ezin du aurrera egin)",
            },
            preferenceGapsPolicy: {
                "label": "Boto baliogabea - Saltatutako Ranken Politika",
                "allowed-warn-and-dialog": "Erakutsi ohartarazpena eta elkarrizketa-koadroa (botatzaileak aurrera egin dezake)",
                "not-allowed-warn-and-dialog": "Erakutsi ohartarazpena eta elkarrizketa-koadroa (botatzaileak ezin du aurrera egin)",
            },
            paginationPolicy: {
                label: "Orri Izena",
            },
            isAcclaimed: {
                label: "Aklamazioz erabakia",
                helperText: "Bozkatzaileek galdera hau ikusten dute baina ezin dute ezer hautatu, ez da ezer erregistratzen eta hautagai guztiak irabazle gisa jasotzen dira zero bozkarekin. Ezarri hau boto-txartelak argitaratu aurretik: ondoren aldatzeak dagoeneko emandako boto-txartelak baliogabetzen ditu.",
            },
            allowWriteins: {
                label: "Eskuzko hautagaitzak baimendu",
            },
            maxVotes: {
                helperText: "Bozkatzaileak aukeratu ahal dituen hautagai kopuru maximoa (ez-hobesentziazko botazioa).",
                helperTextPreferential: "Bozkatzaileek erabil dezaketen posizio altuena (adib. '5' 1-5 posizioak ahalbidetzen ditu). Ordenatu beharreko hautagai kopurua baino gehiago izan behar du (hobesentziazko botazioa).",
            },
            error: {},
            createContestSuccess: "Galdera sortua",
            createContestError: "Errorea galdera sortzerakoan",
        },
        keysGeneration: {
            configureStep: {
                create: "Sortu Giltzen Zeremonia",
                name: "Giltzen Zeremonia Izena",
                allElections: "Hauteskunde Guztiak",
                title: "Sortu Hauteskunde Gertaera Giltzen Zeremonia",
                subtitle: "Giltzen Zeremonoan fideikomisario bakoitzak Hauteskunde Gertaerarako giltza pribatuaren zatia sortuko eta deskargatuko du. Jarraitzeko, mesedez aukeratu zeremonoan parte hartuko duten fideikomisarioak eta atalasea, zenbaketerako behar den fideikomisario gutxieneko kopurua.",
                threshold: "Atalasea",
                trusteeList: "Fideikomisarioak",
                errorMinTrustees_one: "{{selected}} fideikomisario soilik hautatu duzu, baina gutxienez {{threshold}} hautatu behar dituzu.",
                errorMinTrustees_many: "{{selected}} fideikomisario soilik hautatu dituzu, baina gutxienez {{threshold}} hautatu behar dituzu.",
                errorMinTrustees_other: "{{selected}} fideikomisario soilik hautatu dituzu, baina gutxienez {{threshold}} hautatu behar dituzu.",
                errorThreshold: "{{selected}} atalasea hautatu duzu baina {{min}} eta {{max}} artean egon behar da.",
                errorCreatingCeremony: "Errorea Giltzen Zeremonia sortzerakoan: {{error}}",
                createCeremonySuccess: "Giltzen Zeremonia sortua",
                confirmdDialog: {
                    ok: "Bai, Sortu Giltzen Zeremonia",
                    cancel: "Ezeztatu",
                    title: "Ziur zaude Giltzen Zeremonia sortu nahi duzula?",
                    automaticCeremonyTitle: "Ziur zaude giltza-ekitaldi automatiko bat sortu nahi duzula?",
                    description: "Giltzen Zeremonia sortzear zaude. Ekintza honek Fideikomisarioei jakinaraziko die Hauteskunde Gertaera Giltzen sorkuntzan eta banaketan parte har dezaten.",
                    automaticCeremonyDescription: "Giltza-ekitaldi automatiko bat sortzear zaude. Honek ez die arduradunei parte hartzeko jakinaraziko.",
                },
                filterTrustees: "Iragazi Fideikomisarioak",
                errorPermisionLabels: "Errorea Giltzen Zeremonia sortzerakoan: Gutxienez baimen-etiketa bat falta da.",
                automaticCeremonyToggle: "Zeremonia automatikoa",
            },
            ceremonyStep: {
                cancel: "Ezeztatu Giltzen Zeremonia",
                progressHeader: "Giltzen Zeremonia Aurrerapena",
                description: "Pantaila honek Hauteskunde Gertaeraren Giltzen Zeremonaren aurrerapena eta egunkariak erakusten ditu. Giltzen Zeremonoan fideikomisario bakoitzak Hauteskunde Gertaerarako giltza pribatuaren zatia sortuko eta deskargatuko du.",
                executionStatus: "Egoera: {{status}}",
                confirmdDialog: {
                    ok: "Bai, Ezeztatu Giltzen Zeremonia Sortu",
                    cancel: "Itzuli Giltzen Zeremoniara",
                    title: "Ziur zaude Giltzen Zeremonia ezeztatu nahi duzula?",
                    description: "Giltzen Zeremonia ezeztatuera zaude. Ekintza hau egin ondoren, Giltzen Zeremonia arrakastatsua izan dadin berri bat sortu beharko duzu.",
                },
                header: {
                    trusteeName: "Fideikomisario Izena",
                    fragment: "Giltza Zatia Sortua",
                    downloaded: "Giltza Pribatu Zatia Deskargatua",
                    checked: "Giltza Pribatu Zatia Egiaztatua",
                },
                logsHeader: {
                    title: "Egunkariak",
                    date: "Data",
                    entry: "Sarrera",
                },
                emptyLogs: "Ez dago egunkaririk oraindik.",
            },
            startStep: {
                title: "Fideikomisario Giltzen Zeremonia",
                subtitle: "Giltzen Zeremonoan Fideikomisario gisa (<strong>{{name}}</strong>) parte hartzear zaude. Honek urrats hauek dakartza:",
                one: "<strong>Deskargatu</strong> zure Zifratutako Giltza Pribatua.",
                two: "Sortu Zifratutako Giltza Pribatuaren <strong>Babeskopia</strong> anitz.",
                three: "<strong>Egiaztatu</strong> babeskopiak ondo funtzionatzen dutela.",
            },
            downloadStep: {
                title: "Deskargatu Zifratutako Giltza Pribatua",
                subtitle: "Jarraitzeko, mesedez deskargatu eta gorde zure Zifratutako Giltza Pribatua gutxienez bi gailu desberdinetan:",
                downloadButton: "Deskargatu zure Zifratutako Giltza Pribatua",
                downloaded: "Zifratutako Giltza Pribatua behar bezala deskargatu da.",
                errorEmptyKey: "Deskarga errorea, fitxategi hutsa",
                unexpectedError: "Ezin izan da giltza pribatua deskargatu. Saiatu berriro.",
                alreadyVerified: "Zure giltza pribatua deskargatuta eta egiaztatuta zegoen.",
                unavailable: "Giltza pribatuaren deskarga jada ez dago erabilgarri, zeremoniak aurrera egin duelako.",
                confirmdDialog: {
                    ok: "Berretsi Babeskopiak eta Jarraitu",
                    cancel: "Itzuli",
                    title: "Egin babeskopia zure Zifratutako Giltza Pribatuari",
                    description: "Mesedez, egin babeskopia zure Zifratutako Giltza Pribatuari gutxienez bi leku seguru desberdinetan eta gero berretsi behean:",
                    firstCopy: "Lehen babeskopia segurua",
                    secondCopy: "Bigarren babeskopia segurua",
                    confirmError: "Sortu behar diren babeskopiak eta markatu berrespena laukiak jarraitzeko",
                },
            },
            checkStep: {
                title: "Egiaztatu zure Zifratutako Giltza Pribatu Babeskopiak",
                verifyButton: "Egiaztatu gakoa",
                subtitle: "Igo Zifratutako Giltza Pribatu Babeskopia bat zuzena dela egiaztatzeko. Behar adina aldiz saia zaitezke, zure babeskopia desberdinetatik:",
                errorUploading: "Zifratutako Giltza Pribatu Babeskopia baliogabea, mesedez saiatu berriro",
                errorEmptyFile: "Fitxategia hutsa edo ez da aurkitu",
                verified: "Babeskopia arrakastaz egiaztatua.",
                alreadyRestored: "Zure giltza lehendik leheneratuta zegoen.",
            },
        },
        miruExport: {
            create: {
                success: "Transmisio Paketea sortzen...",
                error: "Errorea Transmisio Paketea sortzerakoan ",
            },
            send: {
                success: "Transmisio Paketea bidaltzen...",
                error: "Errorea Transmisio Paketea bidaltzerakoan ",
            },
        },
        tally: {
            numericResultsReportsPending: "Zenbakizko emaitzak osatuta daude. Txostenak sortzen ari dira oraindik.",
            errorUploadingSignature: "Errorea izan da sinadura igotzean",
            downloadTransmissionPackage: "Deskargatu Transmisio Paketea",
            resultsPublication: {
                sectionTitle: "Argitaratu emaitzen webgunean",
                policyTitle: "Emaitzen webgunea",
                policyAccess: "Emaitzen webgunerako sarbidea",
                policyVisibility: "Emaitzen webgunearen ikusgaitasuna",
                enabled: "Gaituta",
                disabled: "Desgaituta",
                fullEvent: "Ekitaldi osoa",
                areaBased: "Eremuaren araberakoa",
                publishStarted: "Emaitzen argitalpena hasi da",
                publishError: "Ezin izan da emaitzen argitalpena hasi",
                revoked: "Emaitzen argitalpena baliogabetu da",
                revokeError: "Ezin izan da emaitzen argitalpena baliogabetu",
                waitingForTally: "Emaitzak zenbaketa hau amaitu ondoren argitaratu daitezke.",
                writePermissionRequired: "publish-results-write baimena behar duzu emaitzak argitaratzeko edo baliogabetzeko.",
                readPermissionRequired: "publish-results-read baimena behar duzu argitalpenen historia ikusteko.",
                disabledPolicy: "Emaitzen webgunean argitaratzea desgaituta dago hauteskunde-ekitaldi honetarako. Gaitu ezazu hauteskunde-ekitaldiaren datuetan emaitzak argitaratu aurretik.",
                loadingElectionContext: "Emaitzen argitalpena hauteskundearen testuingurua kargatzen ari da.",
                route: "Ibilbidea",
                eventResults: "Ekitaldiaren emaitzak",
                electionResults: "Hauteskundearen emaitzak",
                election: "Hauteskundea",
                access: "Sarbidea",
                publicAccess: "Sarbide publikoa",
                authenticatedAccess: "Autentifikatutako sarbidea",
                visibility: "Ikusgaitasuna",
                fullPublishedScope: "Argitaratutako esparru osoa",
                personalVisibility: "Ikusgaitasun pertsonala",
                contests: "Galderak",
                noTalliedContests: "Ez dago zenbatutako galderarik erabilgarri.",
                publishSelectedContests: "Argitaratu hautatutako galderak",
                selectedContestCount_one: "{{count}} galdera hautatuta",
                selectedContestCount_many: "{{count}} galdera hautatuta",
                selectedContestCount_other: "{{count}} galdera hautatuta",
                history: "Argitalpenen historia",
                version: "Bertsioa",
                status: "Egoera",
                published: "Argitaratuta",
                revokedAt: "Baliogabetuta",
                actions: "Ekintzak",
                open: "Ireki",
                revoke: "Baliogabetu",
                noPublications: "Oraindik ez dago argitalpenik.",
                confirmTitle: "Emaitzen webgunean argitaratzen hasi?",
                confirmDescription: "Honek argitalpen berri bat sortuko du uneko zenbaketatik. Bozkatzaileek ikusten dituzten emaitzek aktibo jarraituko dute argitaratze-lan hau ondo amaitu arte.",
                close: "Itxi",
            },
            transmissionPackage: {
                title: "'{{name}}' Eremuaren eta '{{eventName}}' Hauteskundearen Transmisio Paketea",
                description: "Transmisio Paketea Helburu Zerbitzarietara esportatzeko edo deskargatzeko aukera ematen du.",
                actions: {
                    send: {
                        title: "Bidali",
                        dialog: {
                            title: "Transmisio Paketea bidali nahi duzu?",
                            description: "Mesedez, berretsi `{{name}}` Eremuaren Transmisio Paketea Helburu Zerbitzarietara bidali nahi duzula.",
                            confirm: "Bidali Transmisio Paketea",
                            cancel: "Itxi",
                        },
                    },
                    regenerate: {
                        title: "Bersortu",
                        dialog: {
                            title: "Transmisio Paketea bersortu nahi duzu?",
                            description: "Mesedez, berretsi `{{name}}` Eremuaren Transmisio Paketea bersortu nahi duzula",
                            confirm: "Bersortu Transmisio Paketea",
                            cancel: "Itxi",
                        },
                    },
                    sign: {
                        title: "Bersortu",
                        dialog: {
                            title: "Transmisio Paketea sinatu nahi duzu?",
                            description: "Mesedez, berretsi `{{name}}` Eremuaren Transmisio Paketea bersortu nahi duzula",
                            confirm: "Sinatu Transmisio Paketea",
                            cancel: "Itxi",
                            input: {
                                placeholder: "Sartu zure pasahitza",
                            },
                        },
                    },
                    download: {
                        title: "Deskargatu",
                        emlTitle: "Deskargatu EML {{date}}",
                        transmissionPackageTitle: "Deskargatu Transmisio Paketea {{date}}",
                        transmissionReportTitle: "Deskargatu Transmisio Txostena",
                        dialog: {
                            title: "Transmisio Paketea deskargatu nahi duzu?",
                            description: "Mesedez, berretsi `{{name}}` Eremuaren Transmisio Paketea deskargatu nahi duzula.",
                            confirm: "Deskargatu Transmisio Paketea",
                            cancel: "Itxi",
                        },
                    },
                },
                destinationServers: {
                    title: "Helburu Zerbitzariak",
                    description: "Beheko taulak Helburu Zerbitzari bakoitzaren bidaltze egoera erakusten du.",
                    status: "Bidalia {{signed}}/{{total}}",
                    table: {
                        serverName: "Zerbitzari Izena",
                        sendStatus: "Bidaltze Egoera",
                    },
                },
                signatures: {
                    title: "SBEI Sinadurak",
                    description: "SBEIek Transmisio Paketea sinatu dezakete. Beheko taulak SBEI kide bakoitzaren sinadura egoera erakusten du.",
                    status: "{{signed}}/{{total}} Sinatuak, {{minimum}} gutxienez",
                    table: {
                        trusteeName: "SBEI id",
                        signed: "Sinatua du",
                    },
                },
            },
            sendToTransmissionPackageServers: "Bidali Transmisio Paketea '{{name}}' Eremu",
            uploadTransmissionPackage: "Sinatu Transmisio Paketea",
            uploadTransmissionPackageDesc: "Igo zure Sinadura Transmisio Paketea sinatzeko. Aukerako eragiketa da hau.",
            exportElectionArea: "Sortu Transmisio Paketea '{{name}}' Eremu",
            generateReport: "Sortu {{name}}",
            templateTitle: "Emaitzen Txantiloia",
            templateSubTitle: "Aukeran gainidatzi emaitzen txantiloia.",
            keysCeremonyTitle: "Giltzen Zeremonia",
            keysCeremonySubTitle: "Hautatu zenbaketa honetarako Giltzen Zeremonia",
            ceremonyTitle: "Zenbaketan Hauteskundeak",
            initializationTitle: "Hasierako Txostenerako Hauteskundeak",
            ceremonySubTitle: "Aukeratu zenbakatu nahi dituzun hauteskundeak",
            tallyTitle: "Hauteskunde Zenbaketa Aurrerapena",
            logsTitle: "Egunkariak",
            resultsTitle: "Emaitzak eta Parte-hartzea",
            generalInfoTitle: "Informazio Orokorra",
            trusteeTallyTitle: "Fideikomisarioak",
            trusteeTallySubTitle: "Giltza zatiaren inportazio egoera",
            eligibility: {
                selectElection: "Hautatu gutxienez hauteskunde bat.",
                publishElection: "Argitaratu hautatutako hauteskunde bakoitza zenbaketa sortu aurretik.",
                tallyDisallowed: "Zenbaketa desgaituta dago hautatutako hauteskunde batean.",
                endVoting: "Amaitu hautatutako hauteskunde bakoitzeko bozketa eta gelditu kanal aktiboak zenbaketa sortu aurretik.",
            },
            createTallySuccess: "Zenbaketa sortua",
            createTallyError: "Ezin izan da Zenbaketa sortu",
            startTallySuccess: "Zenbaketa hasita",
            startTallyError: "Ezin izan da Zenbaketa hasi",
            startTallyCeremonySuccess: "Zenbaketa Zeremonia hasita",
            startTallyCeremonyError: "Ezin izan da Zenbaketa Zeremonia hasi",
            cancelTallyCeremonySuccess: "Zenbaketa Zeremonia ezeztatua",
            cancelTallyCeremonyError: "Ezin izan da Zenbaketa Zeremonia ezeztatu",
            recountTallyCeremony: "Berriro zenbatu",
            recountTallyCeremonyMessage: "Honek emaitza-gertaera berri bat sortuko du osatutako zenbaketa-saiorako.",
            recountTallyCeremonyStarting: "Birzenbaketa hasten...",
            recountTallyCeremonySuccess: "Birzenbaketa hasita",
            recountTallyCeremonyError: "Ezin izan da birzenbaketa hasi",
            recountTallyCeremonyOk: "Berriro zenbatu",
            trusteeTitle: "Fideikomisarioen prozesua",
            trusteeSubTitle: "Mesedez igo zure giltza zatia",
            invited: "Zenbaketa zeremonoia batean parte hartzeko gonbidatu zaituzte. Mesedez ",
            click: "sakatu zenbaketa Ekintzan",
            participate: "parte hartzeko.",
            breadcrumbSteps: {
                start: "Hasi",
                finish: "Amaitu",
                tally: "Zenbaketa",
                results: "Emaitzak",
                ceremony: "Zeremonia",
            },
            common: {
                title: "Zenbaketa",
                subTitle: "Zenbaketa konfigurazioa.",
                cancel: "Atzera",
                next: "Hurrengoa",
                date: "Zenbaketa Data",
                global: "Orokorra",
                noTrustees: "Ez dago fideikomisariorik oraindik",
                imported: " fideikomisarioak giltza inportatu dute",
                needed: " fideikomisario behar",
                start: "Hasi Zenbaketa",
                ceremony: "Hasi Zenbaketa Zeremonia",
                initialization: "Hasi Hasierako Txostena",
                results: "Emaitzak",
                dialog: {
                    ok: "Ados",
                    okTally: "Hasi Zenbaketa",
                    okCancel: "Ezeztatu Zenbaketa",
                    cancel: "Itxi",
                    title: "Ziur zaude zeremonia bat hasi nahi duzula?",
                    tallyTitle: "Ziur zaude zenbaketa hasi nahi duzula?",
                    cancelTitle: "Ziur zaude zenbaketa ezeztatu nahi duzula?",
                    message: "Zenbaketa zeremonia bat hasi nahian zaude. Ekintza honek fideikomisarioei jakinaraziko die beren giltza zatiak inportatzeko.",
                    cancelMessage: "Zenbaketa zeremonia ezeztatuzera noa. Ekintza hau ezin da desegin.",
                    ceremony: "Beharrezko fideikomisario guztiek beren giltza zatiak egiaztatu dituzte. Dena prest dago emaitzak jasotzen hasteko. Zenbaketa hasi nahi duzu?",
                    startAutomatedTallyMessage: "Hautatu 'Start Tally' zenbaketa-prozesua exekutatzeko eta emaitzak bistaratzeko, edo 'Close' ezeztatzeko.",
                },
            },
            table: {
                elections: "Hauteskundeak",
                selected: "Hautatua",
                status: "Egoera",
                progress: "Aurrerapena",
                method: "Zenbaketa Metodoa",
                elegible: "Bozkatzaile Eskudunak",
                number: "Boto Kopurua",
                total: "Guztira",
                turnout: "%",
                candidates: "Hautagaien Emaitzak",
                options: "Aukerak",
                global: "Parte-hartze Laburpena",
                elegible_census: "Bozkatzaile Eskudunak",
                cast_votes: "Boto Kopurua",
                cast_votes_percent: "Boto Ehunekoa",
                total_votes: "Bozkatzaile Guztiak",
                total_votes_percent: "Parte-hartzea",
                total_votes_counted: "Zenbatutako Boto Guztiak",
                total_auditable_votes: "Auditatu daitezkeen Boto Guztiak",
                total_valid_votes: "Baliozko Boto Guztiak",
                total_valid_votes_percent: "Baliozko Boto Ehunekoa",
                total_invalid_votes: "Baliogabeko Boto Guztiak",
                total_invalid_votes_percent: "Baliogabeko Boto Ehunekoa",
                explicit_invalid_votes: "Esplizituki Baliogabeko Botoak",
                explicit_invalid_votes_percent: "Esplizituki Baliogabeko Boto Ehunekoa",
                implicit_invalid_votes: "Inplizituki Baliogabeko Botoak",
                implicit_invalid_votes_percent: "Inplizituki Baliogabeko Boto Ehunekoa",
                blank_votes: "Boto Zuriak",
                explicit_blank_votes: "Boto Zuri Esplizituak",
                implicit_blank_votes: "Boto Zuri Inplizituak",
                blank_votes_percent: "Boto Zuri Ehunekoa",
                number_of_votes: "Boto Kopurua",
                winning_position: "Irabazle posizioa",
                weight: "Pisua",
                preferential: {
                    candidate: "Hautagaia",
                    winner: "Irabazlea",
                    eliminated: "Baztertua",
                    round: "Txanda",
                },
                total_declined_to_vote: "Bozkatzeari uko egindakoen guztira",
                total_blank_ballots: "Boto-txartel Zuriak Guztira",
                participation_by_channel: "Parte-hartzea kanalaren arabera",
                channel: "Kanala",
                channel_online: "Linean",
                channel_kiosk: "Kioskoa",
                channel_early_voting: "Boto aurreratua",
                channel_telephone: "Telefonoa",
                channel_paper: "Papera",
                channel_postal: "Posta",
                channel_in_person: "Aurrez aurre",
                acclamation_note: "Aklamazioz hautatua. Galdera hau bozketarik gabe erabaki zen, beraz, ez zen bozkarik erregistratu.",
            },
            pendingResolutions: {
                round: "Txanda {{round}}",
                tieResolutionRequired: "Berdinketa ebazpena beharrezkoa",
                tieResolved: "Berdinketa ebatzita",
                globalArea: "Globala",
                pendingResolutionsHeader: "Ebazpen zain",
                pendingResolutionStatus: "Ebazpen zain",
                resolvedStatus: "Ebatzita",
                resolutionTitle: "Ebazpena",
                selectContest: "Hautatu elementu bat ezkerraldean xehetasunak ikusteko",
                selectCandidateToAdvance: "Hautatu aurreratzeko hautagaia",
                undoResolution: "Ebazpena desegin",
                applyResolutions: "Ebazpenak aplikatu eta birkalkulatu",
                submitSuccess: "Ebazpenak bidali dira. Zenbaketa berriro hasten ari da...",
                submitError: "Errorea ebazpenak bidaltzean. Saiatu berriro.",
                filter: "Iragazi",
                save: "Gorde",
                pendingApplyStatus: "Kalkulua zain",
                filterElection: "Hauteskundea",
                filterContest: "Galdera",
                filterArea: "Eremua",
                filterStatusLabel: "Egoera",
                clearFilters: "Iragazkiak garbitu",
                candidateWithVotes: "{{name}} ({{votes}} boto)",
                candidateWithVotesAndPercent: "{{name}} ({{votes}} boto, {{percent}}%)",
                tieInfoTitle: "Zenbaketa etenda berdinketa konpondu gabeagatik (Txanda {{round}})",
                tieInfoBody: "Berdinketako hautagaiak ({{votes}} boto, {{percent}}%): {{candidates}}. Eskuzko desempatea behar da zenbaketa jarraitzeko.",
                tallyResumedTitle: "Zenbaketa berriro hasi da ebazpena aplikatu ondoren",
                tallyResumedBody: "Berdinketa {{date}} egunean {{user}} erabiltzaileak ebatzi zuen",
            },
            chart: {
                votesForCandidates: "Hautagaientzako Botoak",
                blankVotes: "Boto Zuriak",
                invalidVotes: "Boto Baliogabeak",
                totalVoters: "Bozkatzaile Guztiak",
                nonVoters: "Ez-bozkatzaileak",
            },
            exportAllAreas: "Eremu guztien emaitzak {{format}} formatuan esportatu '{{item}}'-rentzat",
        },
        publish: {
            preview: {
                publicationAreas: "Hautatu Eremua Aurreikusteko",
                action: "Aurreikusi",
                copy: "Kopiatu esteka",
                copy_success: "Arrakasta aurreikuspen esteka kopiatzen",
                copy_error: "Huts egin du aurreikuspen esteka kopiatzen",
                success: "Arrakasta aurreikuspena irekitzen",
            },
            header: {
                change: "Argitaratzeko Aldaketak",
                viewChange: "Ikusi Argitalpena",
                history: "Argitalpen Historia",
            },
            action: {
                generateInitializationReport: "Sortu Hasierako Txostena",
                startVotingPeriod: "Hasi Bozketa",
                startKioskVoting: "Hasi Kiosko Bozketa",
                startOnlineVoting: "Hasi Online Bozketa",
                startEarlyVoting: "Hasi Aurre-botoa",
                startTelephoneVoting: "Hasi Telefono Bozketa",
                stopVotingPeriod: "Gelditu Bozketa",
                stopOnlineVoting: "Gelditu Online Bozketa",
                stopEarlyVoting: "Gelditu Aurre-botoa",
                stopTelephoneVoting: "Gelditu Telefono Bozketa",
                stopKioskVotingPeriod: "Gelditu Kiosko Bozketa",
                pauseVotingPeriod: "Pausatu Bozketa",
                pauseKioskVoting: "Pausatu Kiosko Bozketa",
                pauseOnlineVoting: "Pausatu Online Bozketa",
                pauseEarlyVoting: "Pausatu Aurre-botoa",
                pauseTelephoneVoting: "Pausatu Telefono Bozketa",
                generate: "Bersortu",
                publish: "Argitaratu Aldaketak",
                back: "Atzera",
            },
            label: {
                current: "Oraingoa",
                previous: "Aurreko Argitalpena",
                publication: "Argitalpena",
                diff: "Argitaratzeko Aldaketak",
            },
            empty: {
                header: "Ez dago Argitalpen oraindik.",
                action: "Sortu Argitalpena",
            },
            forbidden: {
                header: "Ezin da Argitaratu Giltzen Zeremonia osatu arte.",
            },
            dialog: {
                title: "Berretsi Ekintza",
                info: "Ekintza sentikorr batean klikatu duzu, beraz behar dugu berretsi jarraitzeko",
                initializationInfo: "Hasierako txostena sortzean noa. Ziur zaude jarraitu nahi duzula?",
                startInfo: "Bozketa aldia hasten ari naiz. Ziur zaude jarraitu nahi duzula?",
                stopInfo: "Bozketa aldia gelditzera noa. Ziur zaude jarraitu nahi duzula?",
                kioskStopInfo: "Kiosko bozketa aldia gelditzera noa. Ziur zaude jarraitu nahi duzula?",
                pauseInfo: "Bozketa aldia pausatuzera noa. Ziur zaude jarraitu nahi duzula?",
                publishInfo: "Argitalpen bat sortzera noa. Ziur zaude jarraitu nahi duzula?",
                ok: "Berretsi",
                ko: "Ezeztatu",
                error: "Errorea bozketa argitalpena kargatzerakoan",
                error_publish: "Errorea bozketa argitalpena argitaratzerakoan",
                error_capacity: "Bozketa-estiloa sortzeak huts egin du: {{message}}",
                error_status: "Errorea bozketa argitalpen egoera aldatzerakoan",
                error_preview: "Errorea argitalpena aurreikusterakoan",
                diff: "Aldaketa guztiak errendatzeak orria erantzunik gabe utzi dezake. Ziur zaude jarraitu nahi duzula?",
                confirmation: "Egiteko saiatzen ari zaren ekintza sentikorra da eta berrespena behar du. Mesedez, sartu zure pasahitza {{action}} ekintzarekin jarraitzeko.",
            },
            notifications: {
                generated: "Bozketa sortua",
                published: "Bozketa argitaratua",
                change_status: "Hauteskunde egoera aldatua",
            },
        },
        emailEditor: {
            subject: "Email Gaia",
            tabs: {
                plaintext: "Testu Soilaren Gorputza",
                richtext: "Testu Aberatsaren Gorputza",
            },
        },
        sendCommunication: {
            send: "Bidali",
            title: "Bidali Jakinarazpena",
            subtitle: "Bidali jakinarazpen bat bozkatzaileei.",
            sendButton: "Bidali Jakinarazpena",
            voters: "Entzuleria",
            schedule: "Programatu",
            nowInput: "Orain bidali",
            dateInput: "Jakinarazpenak bidaltzen hasteko data eta ordua",
            chooseDate: "Mesedez aukeratu data bat",
            languages: "Hizkuntzak",
            smsMessage: "SMS Mezua",
            errorSending: "Errorea jakinarazpena bidaltzerakoan: {{error}}",
            successSending: "Jakinarazpena arrakastaz programatu/bidali da",
            method: "Txantiloi Metodoa",
            type: "Komunikazio Mota",
            alias: "Txantiloi Ezizena",
            votersSelection: {
                ALL_USERS: "Denak",
                NOT_VOTED: "Oraindik bozkatu ez dutenak",
                VOTED: "Jadanik bozkatu dutenak",
                SELECTED: "Hautatutako {{total}} {{voters}}",
            },
            path: {
                users: "erabiltzaileak",
                voters: "bozkatzaileak",
            },
            methodTitle: "Komunikazio Txantiloia",
            communicationMethod: {
                EMAIL: "Emaila",
                SMS: "SMS",
            },
            communicationType: {
                CREDENTIALS: "Kredentzialak",
                BALLOT_RECEIPT: "Bozketa Jasoagiria",
            },
            email: {
                subject: "Gaia",
            },
        },
        tallysheet: {
            title: "Bozka-ontziak",
            subtitle: "Bozka-ontzi digitalizatuak kanalean",
            createTallySuccess: "Zenbaketa Orria gordea",
            createTallyError: "Errorea Zenbaketa Orria gordetzerakoan",
            createTallyErrorSameKindExists: "Kontaketa-orria dagoeneko existitzen da galdera honetarako kanal eta eremu berarekin",
            allFieldsRequired: "Eremu guztiak beharrezkoak dira",
            header: {
                change: "Argitaratzeko Aldaketak",
                viewChange: "Ikusi Argitalpena",
                history: "Argitalpen Historia",
            },
            action: {
                start: "Hasi Hauteskundea",
                stop: "Gelditu Hauteskundea",
                pause: "Pausatu",
                generate: "Bersortu",
                publish: "Argitaratu Aldaketak",
                back: "Atzera",
            },
            inputError: {
                totalValidDoesNotMatch: "Hautagaien botoek ({{candidateVotesSum}}) {{lowerBound}} eta {{upperBound}} artean egon behar dute galdera honen bozketa-arauen arabera ({{nonBlankValidVotes}} baliozko boto ez-zuri × gehienez {{maxMarks}} marka boto-txartel bakoitzeko)",
                censusTooSmall: "Boto guztien kopurua ({{totalVotes}}) ezin da erroldakoa ({{census}}) baino handiagoa izan",
                totalInvalidDoesNotMatch: "Boto baliogabeen guztizkoak ({{totalInvalid}}) boto baliogabe inplizituen ({{implicitInvalid}}) eta boto baliogabe esplizituen ({{explicitInvalid}}) baturaren berdina izan behar du",
                totalVotesDoesNotMatch: "Boto guztizkoak ({{totalVotes}}) boto baliodun guztizkoen ({{totalValidVotes}}) eta boto baliogabe guztizkoen ({{totalInvalid}}) baturaren berdina izan behar du",
                unknownCountingAlgorithm: "Galdera honen zenbaketa-algoritmoa ({{countingAlgorithm}}) ez da ezaguna, beraz ezin da zehaztu hautagaien botoen baimendutako kopurua. Egiaztatu galderaren konfigurazioa.",
                blankBallotsInconsistent: "Boto-txartel Zuriak balio berdina izan behar du ontzi honetako kontaketa-orri guztietan",
                blankBallotsOutOfBounds: "Boto-txartel Zuriak balioa ontzi honen galderako boto zurien kontaketek ezartzen duten tartetik kanpo dago",
            },
            label: {
                area: "Eremua",
                channel: "Kanala",
                total_votes: "Boto Guztiak",
                total_valid_votes: "Baliozko Boto Guztiak",
                total_invalid: "Baliogabeko Boto Guztiak",
                explicit_invalid: "Esplizituki Baliogabeko Botoak",
                implicit_invalid: "Inplizituki Baliogabeko Botoak",
                total_blank_votes: "Boto Zuriak",
                blank_ballots: "Boto-txartel Zuriak",
                census: "Zentso",
            },
            common: {
                tallyCeremony: {
                    manage: "Kudeatu Zenbaketa Zeremonia",
                    view: "Ikusi Zenbaketa Zeremonia",
                    cancel: "Ezeztatu Zenbaketa Zeremonia",
                    addKey: "Gehitu Zenbaketa Giltza",
                },
                edit: "Editatu",
                confirm: "Berretsi",
                back: "Atzera",
                next: "Hurrengoa",
                cancel: "Atzera",
                data: "Datuak",
                title: "Zenbaketa Orria",
                subtitle: "Zenbaketa Orri konfigurazioa.",
                candidates: "Hautagaiak",
                save: "Gorde",
                approve: "Onartu",
                disapprove: "Ez onartu",
                show: "Erakutsi",
                add: "Gehitu",
                versions: "Bertsioak",
                warningDisapprove: "Ziur zaude Kontaketa Orri hau ez onartzeko?",
                warningApprove: "Ziur zaude Kontaketa Orri hau onartzeko?",
            },
            empty: {
                header: "Ez dago Zenbaketa Orririk Oraindik.",
                action: "Sortu Zenbaketa Orria",
                add: "Gehitu",
            },
            breadcrumbSteps: {
                start: "Hasi",
                edit: "Editatu",
                confirm: "Berretsi",
                view: "Ikusi",
            },
            table: {
                area: "Eremua",
                contest: "Galdera",
                approvedVersion: "Onartutako bertsioa",
                latestVersion: "Azken bertsioa",
                labels: "Etiketak",
                annotations: "Oharrak",
            },
            versionsTable: {
                title: "Hauntzaren bertsioak",
                version: "Bertsioa",
                createdBy: "Sortzailea",
                reviewedBy: "Berrikustatzailea",
                createdAt: "Sortze data",
                reviewedAt: "Berrikuste data",
                sourceImport: "Jatorrizko inportazioa",
                importStatus: "Inportazioaren egoera",
                openImport: "Ireki inportazioa",
                sourceFile: "Jatorrizko fitxategia",
            },
            message: {
                reviewError: "Errorea zenbaketa orria berrikusterakoan",
                reviewSuccess: "Zenbaketa orria berrikusia",
            },
        },
        application: {
            import: {
                title: "Inportatu aplikazioak",
                subtitle: "Inportatu aplikazioen datuak",
                paragraph: "Inportatu aplikazioak Komaz Banandutako Balioen (CSV) formatuko kalkulu-orri fitxategia erabiliz. Deskargatu inportazio CSV fitxategiaren adibidea hemen.",
                messages: {
                    success: "Aplikazioak arrakastaz inportatuak",
                    error: "Errorea aplikazioak inportatzerakoan",
                },
            },
            export: {
                title: "Esportatu aplikazioak",
                subtitle: "Esportatu aplikazioen datuak",
                button: "Esportatu",
                paragraph: "Esportatu aplikazioen datuak Komaz Banandutako Balioen (CSV) formatuko kalkulu-orri fitxategira.",
                messages: {
                    success: "Aplikazioak arrakastaz esportatuak",
                    error: "Errorea aplikazioak esportatzerakoan",
                },
            },
        },
        template: {
            noPermissions: "Ez duzu txantiloiak atzitzeko baimenik.",
            title: "Txantiloiak",
            subtitle: "Txantiloien zerrenda",
            chooseMethods: "Aukeratu Metodoak",
            default: "Erabili lehenetsitako txantiloia",
            empty: {
                title: "Ez dago Txantiloirik Oraindik",
                subtitle: "Bat sortu nahi duzu?",
            },
            action: {
                createOne: "Sortu Txantiloia",
            },
            create: {
                title: "Sortu Txantiloia",
                success: "Txantiloia sortua",
                error: "Errorea Txantiloia sortzerakoan",
            },
            update: {
                success: "Txantiloia eguneratua",
                error: "Errorea Txantiloia eguneratzerakoan",
            },
            edit: {
                title: "Editatu Txantiloia",
            },
            form: {
                smsMessage: "SMS Mezua",
                document: "Dokumentua",
                pdfOptions: "PDF Aukerak",
                reportOptions: "Txosten Aukerak",
                name: "Txantiloi Izena",
                alias: "Txantiloi Ezizena",
                type: "Mota",
                communicationMethod: "Metodoa",
            },
            type: {
                CREDENTIALS: "Kredentzialak",
                INITIALIZATION_REPORT: "Hasierako Txostena",
                ELECTORAL_RESULTS: "Hauteskunde Emaitzak",
                BALLOT_IMAGES: "Bozketa Irudiak",
                BALLOT_RECEIPT: "Bozketa Jasoagiria",
                ACTIVITY_LOGS: "Jarduera Egunkariak",
                MANUAL_VERIFICATION: "Eskuzko Egiaztapena",
                PARTICIPATION_REPORT: "Parte-hartze Txostena",
            },
            method: {
                email: "Emaila",
                sms: "SMS",
                document: "Dokumentua",
            },
            import: {
                title: "Inportatu Txantiloiak",
                subtitle: "Inportatu txantiloien datuak",
                paragraph: "Inportatu txantiloiak Komaz Banandutako Balioen (CSV) formatuko kalkulu-orri fitxategia erabiliz. Deskargatu inportazio CSV fitxategiaren adibidea hemen.",
            },
        },
        materials: {
            createMaterialSuccess: "Laguntza materiala sortua",
            createMaterialError: "Errorea laguntza materiala sortzerakoan",
            updateMaterialSuccess: "Laguntza materiala eguneratua",
            updateMaterialError: "Errorea laguntza materiala eguneratzerakoan",
            common: {
                title: "Laguntza Materiala",
                subtitle: "Sartu laguntza material datuak.",
            },
            error: {
                title: "Izenburua beharrezkoa da",
                document: "Dokumentua beharrezkoa da",
            },
            fields: {
                isHidden: "Ezkutatuta dago",
                publicUrl: "URL Publikoa",
            },
            empty: {
                header: "Ez dago laguntza materialak",
                action: "Laguntza materiala sortu",
            },
        },
        widget: {
            logs: "Egunkariak",
        },
        settings: {
            countries: {
                title: "Herrialde Blokeoa",
                votingDescription: "Aukeratu behean bozketa blokeatu nahi dituzun herrialdeak.",
                enrollmentDescription: "Aukeratu behean matrikula blokeatu nahi dituzun herrialdeak.",
                error: {
                    errorSaving: "Errorea herrialde zerrenda gordetzerakoan",
                },
            },
            backupRestore: {
                title: "Babeskopia / Leheneratu Maizter konfigurazioa",
                backup: {
                    label: "Babeskopia",
                    subtitle: "Maizter konfigurazioen babeskopia",
                },
                restore: {
                    label: "Leheneratu",
                    subtitle: "Leheneratu Maizter konfigurazioa",
                    title: "Inportatu Maizter Konfigurazioak",
                    paragraph: "Inportatu maizter konfigurazioak, Keycloak konfigurazioak, rol eta baimen datuak zip karpeta erabiliz",
                    tenantConfigOption: "Inportatu Maizter Konfigurazioak",
                    keycloakConfigOption: "Inportatu Keycloak Konfigurazioak",
                    RolesConfigOption: "Inportatu Rol eta Baimen Konfigurazioak",
                },
            },
            previewScreen: {
                label: "Aurreikuspenak",
                noContent: "Ez da aurreikuspenik aurkitu",
                table: {
                    title: "Kanpoko aurrebistak",
                    description: "Kanpoko eskaeren bidez sortutako hautestontzi-estiloen aurrebisten erregistroa",
                    requestedBy: "Eskatzailea",
                    document: "Dokumentua",
                    url: "URLa",
                },
            },
            languages: {
                default: "Lehenetsitako hizkuntza",
            },
        },
        approvalsScreen: {
            column: {
                status: "Egoera",
                id: "IDa",
                applicantId: "Eskaera Egilearen IDa",
                verificationType: "Egiaztapen Mota",
                createdAt: "Sortua:",
                updatedAt: "Eguneratua:",
                verified_by: "Egiaztatua:",
            },
            approvalRequest: "Onespen Eskaria",
            title: "Bozkatzaileak",
            subtitle: "Aurkitu bat datozen bozkatzaileak",
            approve: {
                body: "Ziur zaude bozkatzaile hau onartu nahi duzula? Ekintza hau ezin da alderantzikatu.",
            },
            reject: {
                label: "Baztertu Eskaera",
                confirm: "Ziur zaude bozkatzaile hau baztertu nahi duzula? Ekintza hau ezin da alderantzikatu.",
                rejectReason: "Baztertze Arrazoia",
                message: "Idatzi hemen baztertze arrazoia",
                messageRequired: "'Bestelako' aukerarako baztertze mezu bat beharrezkoa da.",
                reasons: {
                    "undefined": "-",
                    "insufficient-information": "Datu Falta",
                    "no-matching-voter": "Ez dago Bat Datorren Bozkatzailerik",
                    "voter-already-approved": "Jadanik Onartua",
                    "other": "Bestelakoa",
                },
            },
            notifications: {
                approveError: "Errorea bozkatzailea onartzean",
                approveSuccess: "Bozkatzailea onartua",
                rejectError: "Errorea bozkatzailea baztertzean",
                rejectSuccess: "Bozkatzailea baztertua",
                VoterApprovedAlready: "Bozkatzailea jadanik onartua dago.",
            },
            export: {
                success: "Aplikazioen esportazioa arrakastaz amaitua",
                error: "Errorea aplikazioak esportatzerakoan",
            },
        },
        monitoringDashboardScreen: {
            voters: {
                title: "Bozkatzaileak",
                enrolledOverseasVoters: "Matrikulatutako Atzerriko Bozkatzaileak",
                approvalStatus: "Onespen Egoera: Onartutako/Baztertutako Bozkatzaileak",
                manuallyApproval: "Eskuz Onartutako/Baztertutako Bozkatzaileak",
                automaticallyApproval: "Automatikoki Onartutako/Baztertutako Bozkatzaileak",
                authenticatedVoters: "Autentifikatutako Bozkatzaileak",
                invalidUserErrors: "Erabiltzaile Baliogabe Erroreak:",
                invalidPasswordErrors: "Pasahitz Baliogabe Erroreak:",
            },
            polls: {
                title: "Inkestak",
                initializedSystems: "Sistema Hasieratuak dituzten Postuak",
                votingOpened: "Lineko Bozketa Irekia duten Postuak",
                votingClosed: "Bozketa Kanal biak Itxita dituzten Postuak",
                votingStarted: "Bozketa Hasita duten Postuak",
                voterTurnout: "Bozkatzaileen Parte-hartzea",
            },
            tally: {
                title: "Zenbaketa",
                activeVotesCounting: "Boto Zenbaketa Aktiboa duten Postuak",
                generatedERs: "ERak Sortuta dituzten Postuak",
                transmittedResults: "Emaitzak Transmitituta dituzten Postuak",
            },
            testing: {
                title: "Probak",
                testElectionVoterCount: "Proba Hauteskunde Bozkatzaile Kopurua",
            },
        },
        certificateAuthorities: {
            title: "Ziurtagiriak",
            subtitle: "Hauteskunde-ekitaldi honetarako fidagarriak diren ziurtagiri-agintariak (CA). Inportatutako CA-k bozkatzaileen ziurtagiriak egiaztatzeko erabiltzen dira.",
            importButton: "Ziurtagiriak inportatu",
            type: {
                root: "Erroa",
                intermediate: "Tartekoa",
            },
            expiry: {
                expired: "Iraungita",
                expiringSoon: "Laster iraungiko da",
                valid: "Baliozkoa",
            },
            columns: {
                commonName: "Izen arrunta",
                type: "Mota",
                issuerCn: "Eragilearen CN",
                notBefore: "Baliozko hasieratik",
                notAfter: "Iraungitzen da",
                fingerprint: "SHA256 Hatz-marka",
            },
            importDialog: {
                title: "Ziurtagiri-agintaritzak inportatu",
                subtitle: "PEM fitxategi batetik CA ziurtagiri bat edo gehiago inportatu",
                description: "Hautatu ziurtagiri bat edo gehiago dituen PEM fitxategia. Multzoak onartzen dira — ziurtagiri bakoitza banaka inportatzen da.",
                selectFile: "PEM fitxategia hautatu",
                fileLoaded: "Fitxategia kargatuta ({{bytes}} byte)",
                importButton: "Inportatu",
            },
            notify: {
                importSuccess: "{{inserted}} ziurtagiri inportatuta.",
                importSkipped: "{{count}} saltatu (dagoeneko badaude).",
                importErrors: "Inportazio arazoak: {{errors}}",
                importError: "Inportazioa huts egin du: {{error}}",
                deleteSuccess: "Ziurtagiria ezabatuta.",
                deleteError: "Errorea ziurtagiria ezabatzean.",
                exportSuccess: "Ziurtagiri(ak) arrakastaz esportatu da(dira).",
                exportError: "Errorea ziurtagiriak esportatzean.",
            },
            exportDialog: {
                title: "Ziurtagiri-agintaritzak esportatu",
                description: "{{amount}} ziurtagiri esportatuko duzu.",
                all: "guztiak",
            },
            deleteDialog: {
                description: "Ziur zaude {{count}} ziurtagiri(ak) ezabatu nahi dituzula?",
            },
            emptyHeader: "Ez da ziurtagiri-agintaritzarik inportatu hauteskunde-ekitaldi honetarako.",
            fileReadError: "Fitxategia irakurtzean huts egin du.",
            viewDialog: {
                title: "Ziurtagiri-agintaritzaren xehetasunak",
                subject: "Gaia",
                issuer: "Eragilea",
                serialNumber: "Serie-zenbakia",
                pemContent: "PEM edukia",
            },
            confirmDelete: "Ziurtagiri-agintaritza ezabatu",
            confirmDeleteDescription: 'Ziur al zaude "{{name}}" ziurtagiria (hatz-marka: {{fingerprint}}) ezabatu nahi duzula?',
        },
    },
};
export default basqueTranslation;
